/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-4cbeb95d.js';
import '@core/icon-helpers';
import 'prop-types';

var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _switch, _circle2, _circle3, _circle4, _circle5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _circle6, _circle7, _circle8, _path52, _path53, _circle9, _circle0, _path54, _path55, _circle1, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _circle10, _path66, _path67, _path68, _circle11, _path69, _circle12, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _circle13, _circle14, _path123, _path124, _path125, _circle15, _circle16, _path126, _path127, _path128, _circle17, _circle18, _circle19, _path129, _path130, _path131, _path132, _path133, _path134, _circle20, _path135, _circle21, _path136, _path137, _circle22, _path138, _circle23, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _circle24, _path150, _circle25, _path151, _path152, _path153, _circle26, _circle27, _circle28, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _circle29, _path181, _circle30, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _circle31, _path243, _path244, _path245, _circle32, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _circle33, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _circle34, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _circle35, _path330, _circle36, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _circle37, _path341, _path342, _path343, _path344, _path345, _path346, _circle38, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _circle39, _circle40, _circle41, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _circle42, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401;
const didWarnAboutDeprecation = {};
const IbmCloudVirtualServerVpc = /*#__PURE__*/React.forwardRef(function IbmCloudVirtualServerVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "26",
    r: "1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5,30h22c1.1,0,2-.9,2-2v-4c0-1.1-.9-2-2-2H5c-1.1,0-2,.9-2,2v4c0,1.1.9,2,2,2Zm0-6h22v4H5v-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23,20h-14c-3.31,0-6-2.69-6-6,0-3.05,2.29-5.58,5.25-5.95.88-3.5,4.08-6.05,7.75-6.05s6.87,2.55,7.75,6.05c2.96.37,5.25,2.9,5.25,5.95,0,3.31-2.69,6-6,6Zm-14.05-10c-2.18.03-3.95,1.81-3.95,4,0,2.21,1.79,4,4,4h14c2.21,0,4-1.79,4-4,0-2.19-1.76-3.97-3.94-4l-.12.01-.88.02-.12-.88c-.43-2.94-2.98-5.15-5.94-5.15s-5.51,2.21-5.93,5.15l-.12.88-1-.03Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVirtualServerVpc.propTypes = iconPropTypes;
}
const IbmCloudVpc = /*#__PURE__*/React.forwardRef(function IbmCloudVpc({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.4141,22l-13.4141-13.4141V2H2v8h6.5859l13.4141,13.4141v6.5859h8v-8h-6.5859ZM8,8h-4V4h4v4Zm20,20h-4v-4h4v4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30,6c0-2.2056-1.7944-4-4-4-1.8584,0-3.4106,1.2798-3.8579,3h-9.1421v2h9.1421c.3638,1.3989,1.4592,2.4941,2.8579,2.8579v9.1421h2v-9.1421c1.7202-.4473,3-1.9995,3-3.8579Zm-4,2c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m19,25h-9.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-9.1421h-2v9.1421c-1.7202.4473-3,1.9995-3,3.8579,0,2.2056,1.7944,4,4,4,1.8584,0,3.4106-1.2798,3.8579-3h9.1421v-2Zm-13,3c-1.103,0-2-.8975-2-2s.897-2,2-2,2,.8975,2,2-.897,2-2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVpc.propTypes = iconPropTypes;
}
const IbmCloudVpcBlockStorageSnapshots = /*#__PURE__*/React.forwardRef(function IbmCloudVpcBlockStorageSnapshots({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4c-1.1,0-2-.9-2-2v-12h2v12h24V4h-12v-2h12c1.1,0,2,.9,2,2v24c0,1.1-.9,2-2,2ZM22.5,12.1l-6-3c-.3-.1-.6-.1-.9,0l-6,3c-.3.2-.5.5-.6.9v7c0,.4.2.7.6.9l6,3c.3.1.6.1.9,0l6-3c.3-.2.5-.5.6-.9v-7c0-.4-.2-.7-.5-.9h-.1ZM16,11.1l3.8,1.9-3.8,1.9-3.8-1.9s3.8-1.9,3.8-1.9ZM11,14.6l4,2v4.8l-4-2v-4.8ZM17,21.4v-4.8l4-2v4.8s-4,2-4,2ZM0,10h5v2H0v-2ZM12,0v5h-2V0h2ZM3.4,2l3.5,3.5-1.4,1.4-3.5-3.5,1.4-1.4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVpcBlockStorageSnapshots.propTypes = iconPropTypes;
}
const IbmCloudVpcClientVpn = /*#__PURE__*/React.forwardRef(function IbmCloudVpcClientVpn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2c-7.7,0-14,6.3-14,14s6.3,14,14,14h1V2h-1ZM15,4v11h-5c.2-4.2,1.9-8.1,4.8-10.9h.2v-.1ZM15,17v11h-.2c-2.9-2.8-4.6-6.7-4.8-10.9h5v-.1ZM11.5,4.9c-2.1,2.9-3.3,6.4-3.5,10.1h-4c.4-4.6,3.4-8.5,7.5-10.1ZM4,17h4c.2,3.7,1.4,7.2,3.5,10.1-4.1-1.7-7.1-5.5-7.5-10.1ZM29,23h-1v-2c0-1.7-1.3-3-3-3s-3,1.3-3,3v2h-1c-.6,0-1,.4-1,1v5c0,.6.4,1,1,1h8c.6,0,1-.4,1-1v-5c0-.6-.4-1-1-1ZM24,21c0-.6.4-1,1-1s1,.4,1,1v2h-2v-2ZM28,28h-6v-3h6v3ZM25,8c1.7,0,3-1.3,3-3s-1.3-3-3-3-3,1.3-3,3,1.3,3,3,3ZM25,4c.6,0,1,.4,1,1s-.4,1-1,1-1-.4-1-1,.4-1,1-1ZM25,14c.6,0,1,.4,1,1s-.4,1-1,1-1-.4-1-1,.4-1,1-1ZM25,10c.6,0,1,.4,1,1s-.4,1-1,1-1-.4-1-1,.4-1,1-1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVpcClientVpn.propTypes = iconPropTypes;
}
const IbmCloudVpcEndpoints = /*#__PURE__*/React.forwardRef(function IbmCloudVpcEndpoints({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H7a2.0059,2.0059,0,0,1-2-2V12H7V25H20Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4,22l-4-4a3.6057,3.6057,0,0,0,.6-2,4.0118,4.0118,0,0,0-4-4,3.6057,3.6057,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.6057,3.6057,0,0,0-.6,2,4.0118,4.0118,0,0,0,4,4,3.6057,3.6057,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2.0059,2.0059,0,0,1,16,18ZM28,28H24V24h4Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20h2V7a2.0059,2.0059,0,0,0-2-2H12V7H25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVpcEndpoints.propTypes = iconPropTypes;
}
const IbmCloudVpcFileStorage = /*#__PURE__*/React.forwardRef(function IbmCloudVpcFileStorage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13,26H4V6h7.2l3.4,3.4.6.6h12.8v8h2v-8c0-1.1-.9-2-2-2h-12l-3.4-3.4c-.4-.4-.9-.6-1.4-.6h-7.2c-1.1,0-2,.9-2,2v20c0,1.1.9,2,2,2h9s0-2,0-2ZM16,20h14v2h-14v-2ZM16,24h14v2h-14v-2ZM16,28h7v2h-7v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVpcFileStorage.propTypes = iconPropTypes;
}
const IbmCloudVpcImages = /*#__PURE__*/React.forwardRef(function IbmCloudVpcImages({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20H4c-1.1,0-2-.9-2-2V6c0-1.1.9-2,2-2h24c1.1,0,2,.9,2,2v10h-2V6H4v12h26v2ZM2,22h28v2H2v-2ZM2,26h28v2H2v-2ZM16,16c-2.2,0-4-1.8-4-4s1.8-4,4-4,4,1.8,4,4-1.8,4-4,4ZM16,10c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2ZM24,10c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2h0ZM8,10c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2h0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudVpcImages.propTypes = iconPropTypes;
}
const IbmCloudPakApplications = /*#__PURE__*/React.forwardRef(function IbmCloudPakApplications({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21,22H15a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,21,22Zm-6-6v4h6V16Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11,17H9V12a2.0023,2.0023,0,0,1,2-2h6v2H11Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakApplications.propTypes = iconPropTypes;
}
const IbmCloudPakBusinessAutomation = /*#__PURE__*/React.forwardRef(function IbmCloudPakBusinessAutomation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25 16c0-1.5-1.2-2.8-2.7-3-1.1-2.4-3.5-4-6.3-4-.2 0-.5 0-.7.1C14.7 8.4 13.9 8 13 8c-1.7 0-3 1.3-3 3 0 .4.1.7.2 1.1C9.4 13.2 9 14.5 9 16s.4 2.8 1.2 3.9c-.1.4-.2.7-.2 1.1 0 1.7 1.3 3 3 3 .9 0 1.7-.4 2.3-1.1.2 0 .5.1.7.1 2.8 0 5.2-1.7 6.3-4 1.5-.2 2.7-1.5 2.7-3zm-12-6c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm3-1c0-1.7-1.3-3-3-3-.5 0-1 .1-1.4.4-.4-.7-.6-1.5-.6-2.4s.2-1.7.6-2.4c.4.3.9.4 1.4.4 1.7 0 3-1.3 3-3 1.9 0 3.4 1 4.3 2.5-.8.6-1.3 1.5-1.3 2.5s.5 1.9 1.3 2.5C19.4 20 17.9 21 16 21zm6-4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 31c-.2 0-.3 0-.5-.1l-12-7c-.3-.2-.5-.5-.5-.9V9c0-.4.2-.7.5-.9l12-7c.3-.2.7-.2 1 0l12 7-1 1.7L16 3.2 5 9.6v12.9l11 6.4 11-6.4V15h2v8c0 .4-.2.7-.5.9l-12 7c-.2.1-.3.1-.5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakBusinessAutomation.propTypes = iconPropTypes;
}
const IbmCloudPakData = /*#__PURE__*/React.forwardRef(function IbmCloudPakData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "15",
    r: "1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "21",
    cy: "10",
    r: "1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "23",
    r: "1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257A2.9642,2.9642,0,0,0,19,16a3.0033,3.0033,0,0,0-3-3,2.9642,2.9642,0,0,0-1.3187.3187l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258A2.9634,2.9634,0,0,0,13,16a3.0033,3.0033,0,0,0,3,3,2.9634,2.9634,0,0,0,1.3188-.3188l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,17Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakData.propTypes = iconPropTypes;
}
const IbmCloudPakIntegration = /*#__PURE__*/React.forwardRef(function IbmCloudPakIntegration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213,9.8787a3,3,0,0,0-4.2426,0l-.4645.4644,1.4142,1.4142.4645-.4645a1,1,0,0,1,1.4142,1.4144L17.4142,16l1.4143,1.4142,3.2928-3.2929A3,3,0,0,0,22.1213,9.8787Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7071,20.7072a1,1,0,0,1-1.4142-1.4144L14.5858,16l-1.4142-1.4142L9.8787,17.8787a3,3,0,1,0,4.2426,4.2426l.4645-.4644-1.4142-1.4143Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1213,9.8787a3,3,0,0,0-4.2426,4.2426l.4645.4645,1.4142-1.4142-.4645-.4645a1,1,0,0,1,1.4142-1.4143L16,14.5858l1.4142-1.4143Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1213,17.8787l-.4645-.4645-1.4141,1.4142.4644.4645a1,1,0,0,1-1.4142,1.4143L16,17.4142l-1.4142,1.4142,3.2929,3.2929a3,3,0,0,0,4.2426-4.2426Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakIntegration.propTypes = iconPropTypes;
}
const IbmCloudPakMantaAutomatedDataLineage = /*#__PURE__*/React.forwardRef(function IbmCloudPakMantaAutomatedDataLineage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11V5H24V7H14V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4v8a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V9a3.0033,3.0033,0,0,1,3,3v9H11V19H5v6h6V23h6v2a2.0025,2.0025,0,0,0,2,2h5v2h6V23H24v2H19V18h5v2h6V14H24v2H19V12a4.9521,4.9521,0,0,0-1.0254-3H24v2ZM4,12V4h8v8ZM9,23H7V21H9Zm17,2h2v2H26Zm0-9h2v2H26Zm0-9h2V9H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakMantaAutomatedDataLineage.propTypes = iconPropTypes;
}
const IbmCloudPakMulticloudMgmt = /*#__PURE__*/React.forwardRef(function IbmCloudPakMulticloudMgmt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21,19a1.9822,1.9822,0,0,0-.5116.0743L18.707,17.293l-.0257.0257a2.8876,2.8876,0,0,0,0-2.6374l.0257.0257,1.7814-1.7813a2.0345,2.0345,0,1,0-1.4141-1.4141L17.293,13.293l.0257.0257a2.8876,2.8876,0,0,0-2.6374,0l.0257-.0257-1.7813-1.7814a2.0345,2.0345,0,1,0-1.4141,1.4141L13.293,14.707l.0258-.0258a2.8872,2.8872,0,0,0,0,2.6376l-.0258-.0258-1.7814,1.7813a2.0345,2.0345,0,1,0,1.4141,1.4141L14.707,18.707l-.0258-.0258a2.8872,2.8872,0,0,0,2.6376,0l-.0258.0258,1.7813,1.7814A1.9956,1.9956,0,1,0,21,19Zm-5-2a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,17Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakMulticloudMgmt.propTypes = iconPropTypes;
}
const IbmCloudPakNetezza = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetezza({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19 10L19 19.2 13.5 10 11 10 11 22 13 22 13 12.8 18.5 22 21 22 21 10z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30C8.3,30,2,23.7,2,16S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z M16,4C9.4,4,4,9.4,4,16s5.4,12,12,12s12-5.4,12-12 S22.6,4,16,4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakNetezza.propTypes = iconPropTypes;
}
const IbmCloudPakNetworkAutomation = /*#__PURE__*/React.forwardRef(function IbmCloudPakNetworkAutomation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3638,21.364,20.95,19.95a6.9993,6.9993,0,0,0,0-9.899L22.3638,8.636a9,9,0,0,1,0,12.728Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356,18.5354l-1.414-1.4141a3.0039,3.0039,0,0,0,0-4.2426l1.414-1.4141A5.0048,5.0048,0,0,1,19.5356,18.5354Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M17,26H15V15a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4644,18.5354a5.0048,5.0048,0,0,1,0-7.0708l1.414,1.4141a3.0039,3.0039,0,0,0,0,4.2426Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6362,21.364a9,9,0,0,1,0-12.728L11.05,10.0505a6.9993,6.9993,0,0,0,0,9.899Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakNetworkAutomation.propTypes = iconPropTypes;
}
const IbmCloudPakSecurity = /*#__PURE__*/React.forwardRef(function IbmCloudPakSecurity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.7285a6.0069,6.0069,0,0,1-6-6v-6.457l6-3,6,3v6.457A6.0069,6.0069,0,0,1,16,23.7285ZM12,12.5073v5.2212a4,4,0,0,0,8,0V12.5073l-4-2Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakSecurity.propTypes = iconPropTypes;
}
const IbmCloudPakSystem = /*#__PURE__*/React.forwardRef(function IbmCloudPakSystem({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.671H17V15.328H15z",
    transform: "rotate(-45 16 13.5)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.672H17V20.329H15z",
    transform: "rotate(-45 16 18.5)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M19,24H13a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,19,24ZM13,10V22h6.0012L19,10Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakSystem.propTypes = iconPropTypes;
}
const IbmCloudPakWatsonAiops = /*#__PURE__*/React.forwardRef(function IbmCloudPakWatsonAiops({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14,24a1,1,0,0,1-.9614-.7253L11.2456,17H8V15h4a1,1,0,0,1,.9614.7253L14,19.36,17.0386,8.7253a1,1,0,0,1,1.9228,0L20.7544,15H24v2H20a1,1,0,0,1-.9614-.7253L18,12.64,14.9614,23.2747A1,1,0,0,1,14,24Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31a.9988.9988,0,0,1-.5039-.1357l-12-7A1.0008,1.0008,0,0,1,3,23V9a.9994.9994,0,0,1,.4961-.8638l12-7a1,1,0,0,1,1.0078,0l12,7L27.4961,9.8638,16,3.1577,5,9.5742V22.4258l11,6.417,11-6.417V15h2v8a1.0008,1.0008,0,0,1-.4961.8643l-12,7A.9988.9988,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmCloudPakWatsonAiops.propTypes = iconPropTypes;
}
const IbmConsultingAdvantageAgent = /*#__PURE__*/React.forwardRef(function IbmConsultingAdvantageAgent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,31c-5.24,0-9.5-4.26-9.5-9.5s4.26-9.5,9.5-9.5,9.5,4.26,9.5,9.5c0,1.74-.47,3.43-1.36,4.91.1.52.65,1.9,1.26,3.15.19.38.11.84-.19,1.14s-.76.38-1.14.2c-1.27-.61-2.68-1.15-3.2-1.24-1.47.88-3.15,1.34-4.87,1.34ZM26.56,29.54h0ZM21.5,14c-4.14,0-7.5,3.36-7.5,7.5s3.36,7.5,7.5,7.5c1.42,0,2.8-.4,4-1.15.26-.17.7-.44,2.57.23-.69-1.84-.42-2.26-.24-2.54.77-1.2,1.18-2.6,1.18-4.04,0-4.14-3.36-7.5-7.5-7.5h-.01ZM29.51,26.61h0ZM23.63,21c0,.55.45,1,1,1s1-.45,1-1-.45-1-1-1-1,.45-1,1ZM18.63,21c0,.55.45,1,1,1s1-.45,1-1-.45-1-1-1-1,.45-1,1ZM24.58,23c-.63.62-1.5,1-2.45,1s-1.82-.38-2.45-1l-1.4,1.43c.99.97,2.35,1.57,3.85,1.57s2.85-.6,3.85-1.57l-1.4-1.43ZM10,28h-5.38L16,5.23l2.61,5.21,1.79-.89-3.5-7c-.34-.68-1.45-.68-1.79,0L2.1,28.55c-.16.31-.14.68.04.97.18.29.5.47.85.47h7v-2l.01.01Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmConsultingAdvantageAgent.propTypes = iconPropTypes;
}
const IbmConsultingAdvantageApplication = /*#__PURE__*/React.forwardRef(function IbmConsultingAdvantageApplication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6c-1.1,0-2-.9-2-2V6c0-1.1.9-2,2-2h22v2H6v20h20V8h2v18c0,1.1-.9,2-2,2ZM15,10h-5v5h5v-5ZM22,10h-5v5h5v-5ZM15,17h-5v5h5v-5ZM22,17h-5v5h5v-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmConsultingAdvantageApplication.propTypes = iconPropTypes;
}
const IbmConsultingAdvantageAssistant = /*#__PURE__*/React.forwardRef(function IbmConsultingAdvantageAssistant({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.72,0-14-6.28-14-14S8.28,2,16,2s14,6.28,14,14c0,2.62-.73,5.18-2.11,7.39.05.74,1.05,3.21,2.01,5.17.19.38.11.84-.19,1.14-.3.3-.76.38-1.14.2-1.99-.96-4.5-1.94-5.24-1.97-2.2,1.35-4.73,2.07-7.33,2.07ZM16,4c-6.62,0-12,5.38-12,12s5.38,12,12,12c2.27,0,4.48-.64,6.39-1.84.32-.21,1.01-.63,4.58.84-1.5-3.54-1.07-4.22-.87-4.54,1.23-1.93,1.89-4.16,1.89-6.46,0-6.62-5.38-12-12-12h.01ZM23.83,20.87l-1.67-1.11c-.37.56-.85,1.03-1.4,1.4-2.3,1.53-5.4.9-6.93-1.4l-1.67,1.11c1.3,1.96,3.49,3.13,5.83,3.13,2.35,0,4.54-1.17,5.83-3.13h.01ZM22,13c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c.01-1.09-.87-1.99-1.96-2h-.04ZM14,13c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2c.01-1.09-.87-1.99-1.96-2h-.04Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmConsultingAdvantageAssistant.propTypes = iconPropTypes;
}
const IbmDevopsControl = /*#__PURE__*/React.forwardRef(function IbmDevopsControl({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27,24c-1.302,0-2.4016.8389-2.8157,2h-2.5662l-1.5579-3.1157c2.3552-1.3921,3.9397-3.9502,3.9397-6.8843s-1.5845-5.4922-3.9397-6.8843l1.5576-3.1157h2.5664c.4141,1.1611,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8389-2.8157,2h-2.5664c-.7622,0-1.4475.4238-1.7888,1.1055l-1.6069,3.2139c-.7063-.2041-1.4502-.3193-2.2222-.3193s-1.5159.1152-2.2222.3193l-1.6072-3.2139c-.3411-.6816-1.0264-1.1055-1.7886-1.1055h-2.5664c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h2.5662l1.5579,3.1157c-2.3552,1.3921-3.9397,3.9502-3.9397,6.8843s1.5845,5.4922,3.9397,6.8843l-1.5576,3.1157h-2.5664c-.4141-1.1611-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8389,2.8157-2h2.5664c.7622,0,1.4475-.4238,1.7888-1.1055l1.6069-3.2139c.7063.2041,1.4502.3193,2.2222.3193s1.5159-.1152,2.2222-.3193l1.6072,3.2139c.3411.6816,1.0264,1.1055,1.7886,1.1055h2.5664c.4141,1.1611,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3ZM27,4c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1ZM5,6c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1ZM5,28c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1ZM10.2856,16c0-3.1509,2.5635-5.7144,5.7144-5.7144s5.7144,2.5635,5.7144,5.7144-2.5635,5.7144-5.7144,5.7144-5.7144-2.5635-5.7144-5.7144ZM27,28c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1ZM18.5901,12.5566l1.4099,1.4434-5,5-3-3,1.4441-1.4438,1.5605,1.6221,3.5854-3.6216Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmDevopsControl.propTypes = iconPropTypes;
}
const IbmQuantumSafeAdvisor = /*#__PURE__*/React.forwardRef(function IbmQuantumSafeAdvisor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.44c0,4.96-4.68,7.7-8.45,9.9-.54.32-1.07.62-1.55.92-.49-.3-1.01-.61-1.55-.92-3.76-2.2-8.45-4.94-8.45-9.9V4h21v-2H6c-1.1,0-2,.9-2,2v12.44c0,6.11,5.45,9.3,9.44,11.63.72.42,1.41.82,2.02,1.22l.54.35.54-.35c.61-.39,1.3-.79,2.02-1.22,3.98-2.33,9.44-5.52,9.44-11.63v-3.62c1.16-.41,2-1.51,2-2.82,0-1.65-1.35-3-3-3s-3,1.35-3,3c0,1.3.84,2.4,2,2.82v3.62ZM27,11c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM21,9h-8v-2h8v2ZM21,21h-8v-2h8v2ZM15,13h8v1.99h-8v-1.99ZM9.71,17.71l-1.41-1.41,2.29-2.29-2.29-2.29,1.41-1.41,3.71,3.71-3.71,3.71v-.02Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmQuantumSafeAdvisor.propTypes = iconPropTypes;
}
const IbmQuantumSafeExplorer = /*#__PURE__*/React.forwardRef(function IbmQuantumSafeExplorer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10,18h8v2h-8v-2ZM28,12.82v3.62c0,6.11-5.45,9.3-9.44,11.63-.72.42-1.41.82-2.02,1.22l-.54.35-.54-.35c-.61-.39-1.3-.79-2.02-1.22-3.98-2.33-9.44-5.52-9.44-11.63V4c0-1.1.9-2,2-2h21v2H6v9h6v2h-6v1.44c0,4.96,4.68,7.7,8.45,9.9.54.32,1.07.62,1.55.92.49-.3,1.01-.61,1.55-.92,2.75-1.6,5.97-3.5,7.52-6.33h-5.08v-2h5.83c.11-.5.17-1.01.17-1.56v-3.62c-1.16-.41-2-1.51-2-2.82,0-1.65,1.35-3,3-3s3,1.35,3,3c0,1.3-.84,2.4-2,2.82l.01-.01ZM28,10c0-.55-.45-1-1-1s-1,.45-1,1,.45,1,1,1,1-.45,1-1ZM22,13h-8v2h8v-2ZM18,8h-8v2h8v-2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmQuantumSafeExplorer.propTypes = iconPropTypes;
}
const IbmQuantumSafeRemediator = /*#__PURE__*/React.forwardRef(function IbmQuantumSafeRemediator({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16.44c0,4.96-4.68,7.7-8.45,9.9-.54.32-1.07.62-1.55.92-.49-.3-1.01-.61-1.55-.92-3.76-2.2-8.45-4.94-8.45-9.9V4h21v-2H6c-1.1,0-2,.9-2,2v12.44c0,6.11,5.45,9.3,9.44,11.63.72.42,1.41.82,2.02,1.22l.54.35.54-.35c.61-.39,1.3-.79,2.02-1.22,3.98-2.33,9.44-5.52,9.44-11.63v-3.62c1.16-.41,2-1.51,2-2.82,0-1.65-1.35-3-3-3s-3,1.35-3,3c0,1.3.84,2.4,2,2.82v3.62ZM27,11c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1ZM16,18c-1.48,0-2.77-.8-3.46-2l1.73-1c.35.6.99,1,1.73,1,1.1,0,2-.9,2-2s-.9-2-2-2v-2c2.21,0,4,1.79,4,4s-1.79,4-4,4ZM16,22c-.68,0-1.38-.09-2.07-.27-4.26-1.14-6.8-5.54-5.66-9.8,1.14-4.26,5.54-6.8,9.8-5.66l-.52,1.93c-3.2-.86-6.49,1.05-7.35,4.24-.86,3.2,1.05,6.49,4.24,7.35,3.19.86,6.49-1.05,7.35-4.24l1.93.52c-.96,3.57-4.2,5.93-7.73,5.93h.01Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmQuantumSafeRemediator.propTypes = iconPropTypes;
}
const IbmSecurity = /*#__PURE__*/React.forwardRef(function IbmSecurity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16,.0005,4,5.9784V20.0443a12,12,0,0,0,24,0V5.9784Zm6.83,27.3138L16,23.9119V26.14l5.0361,2.5088A10.0025,10.0025,0,0,1,6,20.0443V7.21L16,2.2284,26,7.21v3.75L16,5.9783V8.2062l10,4.9816v3.75L16,11.9562v2.2279l10,4.9815v.8787a9.9045,9.9045,0,0,1-.37,2.6871L16,17.934v2.2279l8.8952,4.4313A10.0252,10.0252,0,0,1,22.83,27.3143Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSecurity.propTypes = iconPropTypes;
}
const IbmSecurityServices = /*#__PURE__*/React.forwardRef(function IbmSecurityServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20a2.97,2.97,0,0,0-1.8551.6607L22,19.4224V17.8157a3,3,0,1,0-2,0v1.6067l-2.1449,1.2383A2.97,2.97,0,0,0,16,20a3.02,3.02,0,1,0,2.9254,2.3525L21,21.1548l2.0746,1.1977A2.9978,2.9978,0,1,0,26,20ZM16,24a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,16,24Zm5-10a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,14Zm5,10a1,1,0,1,1,1-1A1.0006,1.0006,0,0,1,26,24Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31A11.0125,11.0125,0,0,1,5,20V6.3823L15.9873.8816,26.4478,6.1187l-.8956,1.7885L15.9873,3.1184,7,7.6177V20a9.0008,9.0008,0,0,0,14.3994,7.2012L22.6006,28.8A10.9077,10.9077,0,0,1,16,31Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmSecurityServices.propTypes = iconPropTypes;
}
const IbmWatsonAssistant = /*#__PURE__*/React.forwardRef(function IbmWatsonAssistant({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["IbmWatsonAssistant"]) {
      didWarnAboutDeprecation["IbmWatsonAssistant"] = true;
      console.warn("Icon renamed and replaced by ibm-watsonx--assistant to correspond with the new watsonx platform and product suite. As a result, the IbmWatsonAssistant component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H18c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h2.4l1.7,3l1.7-1l-2.3-4H18V4h10v6h-3v2h3c1.1,0,2-0.9,2-2V4 C30,2.9,29.1,2,28,2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7,31L13,30l3.5-6H22c1.1,0,2-0.9,2-2v-5h2v5c0,2.2-1.8,4-4,4h-4.4L14.7,31z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12,26H6c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h8v2H6c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6V26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonAssistant.propTypes = iconPropTypes;
}
const IbmWatsonDiscovery = /*#__PURE__*/React.forwardRef(function IbmWatsonDiscovery({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17H14V19H6z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "18",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "14",
    r: "1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13H10V15H2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9H14V11H6z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "10",
    r: "1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-7.4-7.4c1.5-2,2.4-4.5,2.4-7.2c0-6.6-5.4-12-12-12C9.7,2,6.6,3.3,4.3,5.8l1.5,1.4C7.6,5.1,10.2,4,13,4 c5.5,0,10,4.5,10,10s-4.5,10-10,10c-3,0-5.8-1.3-7.7-3.6l-1.5,1.3C6,24.4,9.4,26,13,26c3.2,0,6.1-1.3,8.3-3.3l7.3,7.3L30,28.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonDiscovery.propTypes = iconPropTypes;
}
const IbmWatsonKnowledgeCatalog = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeCatalog({
  children,
  size = 16,
  ...rest
}, ref) {
  if (process.env.NODE_ENV !== "production") {
    if (!didWarnAboutDeprecation["IbmWatsonKnowledgeCatalog"]) {
      didWarnAboutDeprecation["IbmWatsonKnowledgeCatalog"] = true;
      console.warn("Icon renamed, slightly redesigned and replaced by ibm--knowledge-catalog. As a result, the IbmWatsonKnowledgeCatalog component will be removed in the next major version of @carbon/icons-react.");
    }
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 30 23 28.6 21.6z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H20V20H12z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13H20V15H12z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8H20V10H12z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28H6v-4h2v-2H6v-5h2v-2H6v-5h2V8H6V4h18v16h2V4c0-1.1-0.9-2-2-2H6C4.9,2,4,2.9,4,4v4H2v2h2v5H2v2h2v5H2v2h2v4 c0,1.1,0.9,2,2,2h10V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonKnowledgeCatalog.propTypes = iconPropTypes;
}
const IbmWatsonKnowledgeStudio = /*#__PURE__*/React.forwardRef(function IbmWatsonKnowledgeStudio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25H27V27H20z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29H25V31H22z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M27,23h-2c0-1.1,0.4-2,1.2-2.8l0.5-0.5c0.8-0.8,1.3-2,1.3-3.2c0-2.5-2-4.5-4.5-4.5S19,14,19,16.5c0,1.2,0.5,2.3,1.3,3.2 l0.5,0.5C21.6,21,22,21.9,22,23h-2c0-0.5-0.2-1-0.6-1.4l-0.5-0.5c-1.2-1.2-1.9-2.9-1.9-4.6c0-3.6,2.9-6.5,6.5-6.5s6.5,2.9,6.5,6.5 c0,1.7-0.7,3.4-1.9,4.6l-0.5,0.5C27.2,22,27,22.5,27,23z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H14V24H6z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H9V20H6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H13V16H6z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H17V12H10z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "11",
    r: "1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6H20V8H16z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "7",
    r: "1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H10V8H6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28H4V4l18,0v4h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v24c0,1.1,0.9,2,2,2h14V28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonKnowledgeStudio.propTypes = iconPropTypes;
}
const IbmWatsonLanguageTranslator = /*#__PURE__*/React.forwardRef(function IbmWatsonLanguageTranslator({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28h-3c-3.9,0-7-3.1-7-7v-4h2v4c0,2.8,2.2,5,5,5h3V28z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30h2.2l-4.6-11h-2.2l-4.6,11H21l0.8-2h5.3L28,30z M22.7,26l1.8-4.4l1.8,4.4H22.7z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28,15h-2v-4c0-2.8-2.2-5-5-5h-4V4h4c3.9,0,7,3.1,7,7V15z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M14,5V3H9V1H7v2H2v2h8.2C10,5.9,9.4,7.5,8,9C7.4,8.3,6.9,7.6,6.6,7H4.3c0.4,1,1.1,2.2,2.1,3.3C5.6,11,4.4,11.6,3,12.1 L3.7,14c1.8-0.7,3.2-1.5,4.3-2.3c1.1,0.9,2.5,1.7,4.3,2.3l0.7-1.9c-1.4-0.5-2.6-1.2-3.5-1.8c1.9-2,2.5-4.1,2.7-5.3H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonLanguageTranslator.propTypes = iconPropTypes;
}
const IbmWatsonMachineLearning = /*#__PURE__*/React.forwardRef(function IbmWatsonMachineLearning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6,22.5c-1-2-1.6-4.2-1.6-6.5C2,8.3,8.3,2,16,2v2C9.4,4,4,9.4,4,16c0,2,0.5,3.8,1.4,5.5L3.6,22.5z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16c0,6.6-5.4,12-12,12c-2.9,0-5.6-1-7.7-2.8l5.7-5.7L12.6,18l-6.5,6.5c-0.4,0.4-0.4,1,0,1.4C8.7,28.5,12.3,30,16,30 c7.7,0,14-6.3,14-14H28z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M18,25c-0.1,0-0.3,0-0.4-0.1c-0.3-0.1-0.6-0.4-0.6-0.8l-0.7-5l2-0.3l0.4,3.3l2.2-1.7V15c0-0.3,0.1-0.5,0.3-0.7l3.2-3.2 c0.9-0.9,1.5-2.2,1.5-3.5V6l-1.5,0c-1.3,0-2.6,0.5-3.5,1.5l-3.2,3.2C17.5,10.9,17.3,11,17,11h-5.5l-1.7,2.2l3.3,0.4l-0.3,2l-5-0.7 c-0.4,0-0.7-0.3-0.8-0.6s-0.1-0.7,0.1-1l3-4C10.4,9.1,10.7,9,11,9h5.6l3-3c1.3-1.3,3.1-2,4.9-2H26c1.1,0,2,0.9,2,2v1.5 c0,1.9-0.7,3.6-2,4.9l-3,3V21c0,0.3-0.1,0.6-0.4,0.8l-4,3C18.4,24.9,18.2,25,18,25z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonMachineLearning.propTypes = iconPropTypes;
}
const IbmWatsonNaturalLanguageClassifier = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageClassifier({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2h-4c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h1v4h-3v2h8v-2h-3v-4H28z M24,4h4v6h-4V4z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22.4L19.6 21 16 24.6 12.4 21 11 22.4 14.6 26 11 29.6 12.4 31 16 27.4 19.6 31 21 29.6 17.4 26z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18L15 18 15 21 17 21 17 18 20 18 20 16 12 16z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10,12V4c0-1.1-0.9-2-2-2H3v2h5v2H4C2.9,6,2,6.9,2,8v2c0,1.1,0.9,2,2,2h1v4H2v2h8v-2H7v-4H10z M4,8h4v2H4V8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonNaturalLanguageClassifier.propTypes = iconPropTypes;
}
const IbmWatsonNaturalLanguageUnderstanding = /*#__PURE__*/React.forwardRef(function IbmWatsonNaturalLanguageUnderstanding({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H11V25H6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19H11V21H6z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30H4c-1.1,0-2-0.9-2-2V17c0-1.1,0.9-2,2-2h9c1.1,0,2,0.9,2,2v11C15,29.1,14.1,30,13,30z M4,17v11h9V17H4z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M19 2H27V4H19z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M22 6H30V8H22z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H30V12H22z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14H27V16H19z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H30V20H22z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M12,1l-1.4,1.4L13.2,5H4C2.9,5,2,5.9,2,7v5h2V7h9.2l-2.6,2.6L12,11l5-5L12,1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonNaturalLanguageUnderstanding.propTypes = iconPropTypes;
}
const IbmWatsonOpenscale = /*#__PURE__*/React.forwardRef(function IbmWatsonOpenscale({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M4,28c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S5.7,28,4,28z M4,24c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S4.6,24,4,24z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S29.7,28,28,28z M28,24c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S28.6,24,28,24z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4,4.4l-0.9,1.8C26.1,8.4,29,13,29,18c0,0.7-0.1,1.4-0.2,2.1l2,0.3c0.1-0.8,0.2-1.6,0.2-2.5C31,12.2,27.6,6.9,22.4,4.4z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16,7c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,7,16,7z M16,3c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S16.6,3,16,3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,13.6l-1-1.7L17,16.3V9h-2v7.2L6.2,11c-0.5-0.3-1.1-0.1-1.4,0.3s-0.1,1.1,0.3,1.4L14,18l-6.2,3.6l1,1.7l6.2-3.6V30 c0,0.6,0.4,1,1,1s1-0.4,1-1V19.8l6.2,3.7l1-1.7L18,18L25.5,13.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonOpenscale.propTypes = iconPropTypes;
}
const IbmWatsonOrders = /*#__PURE__*/React.forwardRef(function IbmWatsonOrders({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M28,13h-2v-2c0-2.8-2.2-5-5-5h-3V4h3c3.9,0,7,3.1,7,7V13z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20H25V22H22z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H25V26H22z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M27,30h-5v-2h5V18h-7v9c0,1.7-1.3,3-3,3s-3-1.3-3-3v-3h2v3c0,0.6,0.4,1,1,1s1-0.4,1-1V16h11v12C29,29.1,28.1,30,27,30z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28h-1c-3.9,0-7-3.1-7-7v-4h2v4c0,2.8,2.2,5,5,5h1V28z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M11,10v2h3c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v6c0,1.1,0.9,2,2,2h2.4l1.7,3l1.7-1l-2.3-4H4V4h10v6H11z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonOrders.propTypes = iconPropTypes;
}
const IbmWatsonQuery = /*#__PURE__*/React.forwardRef(function IbmWatsonQuery({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24c-0.2,0-0.3,0-0.5,0L18.2,18c0.5-0.5,0.8-1.2,0.8-2c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.8,0.3,1.5,0.8,2L10.5,24 c-0.2,0-0.3,0-0.5,0c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.8-0.3-1.5-0.8-2l3.3-6.1c0.2,0,0.3,0,0.5,0s0.3,0,0.5,0l3.3,6.1 c-0.5,0.5-0.8,1.2-0.8,2c0,1.7,1.3,3,3,3s3-1.3,3-3S23.7,24,22,24z M16,15c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S15.4,15,16,15z M10,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S10.6,28,10,28z M22,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S22.6,28,22,28z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8,9.1C23.9,5,20.3,2,16,2S8.1,5,7.2,9.1C4.2,9.7,2,12.4,2,15.5C2,19.1,4.9,22,8.5,22H9v-2H8.5C6,20,4,18,4,15.5 c0-2.3,1.8-4.3,4.1-4.5L9,11l0.1-0.8C9.5,6.6,12.5,4,16,4c3.5,0,6.5,2.6,6.9,6.1L23,11l0.8,0.1c2.3,0.2,4.1,2.2,4.1,4.5 c0,2.5-2,4.5-4.5,4.5H23v2h0.5c3.6,0,6.5-2.9,6.5-6.5C30,12.4,27.8,9.7,24.8,9.1z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonQuery.propTypes = iconPropTypes;
}
const IbmWatsonSpeechToText = /*#__PURE__*/React.forwardRef(function IbmWatsonSpeechToText({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M14,18H4c-1.1,0-2,0.9-2,2v6c0,1.1,0.9,2,2,2h2.4l1.7,3l1.7-1l-2.3-4H4v-6h10v6h-3v2h3c1.1,0,2-0.9,2-2v-6 C16,18.9,15.1,18,14,18z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M19,26h2c3.9,0,7-3.1,7-7v-2h-2v2c0,2.8-2.2,5-5,5h-2V26z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11H24V13H18z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7H30V9H18z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3H30V5H18z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M4,14h2v-2c0-2.8,2.2-5,5-5h4V5h-4c-3.9,0-7,3.1-7,7V14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonSpeechToText.propTypes = iconPropTypes;
}
const IbmWatsonStudio = /*#__PURE__*/React.forwardRef(function IbmWatsonStudio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M25,21c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S27.8,21,25,21z M25,13c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3S26.7,13,25,13z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11V6c0-1.1-0.9-2-2-2h-2v2h2v5c0,2.1,1.1,3.9,2.7,5c-1.6,1.1-2.7,2.9-2.7,5v5h-2v2h2c1.1,0,2-0.9,2-2v-5 c0-2.2,1.8-4,4-4v-2C15.8,15,14,13.2,14,11z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M2,30v-6h6v6H2z M4,26v2h2v-2H4z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M2,19v-6h6v6H2z M4,15v2h2v-2H4z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M2,8V2h6v6H2z M4,4v2h2V4H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonStudio.propTypes = iconPropTypes;
}
const IbmWatsonTextToSpeech = /*#__PURE__*/React.forwardRef(function IbmWatsonTextToSpeech({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M13,26h-2c-3.9,0-7-3.1-7-7v-2h2v2c0,2.8,2.2,5,5,5h2V26z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M18,18h10c1.1,0,2,0.9,2,2v6c0,1.1-0.9,2-2,2h-2.4l-1.7,3l-1.7-1l2.3-4H28v-6H18v6h3v2h-3c-1.1,0-2-0.9-2-2v-6 C16,18.9,16.9,18,18,18z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14h-2v-2c0-2.8-2.2-5-5-5h-4V5h4c3.9,0,7,3.1,7,7V14z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H8V13H2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H14V9H2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3H14V5H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonTextToSpeech.propTypes = iconPropTypes;
}
const IbmWatsonToneAnalyzer = /*#__PURE__*/React.forwardRef(function IbmWatsonToneAnalyzer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9,10c-0.6-0.6-1.5-1-2.4-1s-1.8,0.4-2.4,1l-1.4-1.4c1-1,2.4-1.6,3.8-1.6s2.9,0.6,3.8,1.6L23.9,10z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "5",
    r: "1"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "5",
    r: "1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M15,0l13,0c1.1,0,2,0.9,2,2v10c0,1.1-0.9,2-2,2h-3.5l-1.7,3L21,16l2.3-4H28V2H15v10h5v2h-5c-1.1,0-2-0.9-2-2V2 C13,0.9,13.9,0,15,0z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M20,19v6c0,0.6-0.4,1-1,1h-5v2h5c1.7,0,3-1.3,3-3v-6H20z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,20.4c-0.8,1-2.1,1.6-3.4,1.6s-2.6-0.6-3.4-1.6L7,21.6c1.2,1.4,3,2.4,5,2.4s3.8-0.9,5-2.4L15.4,20.4z"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "17.5",
    r: "1.5"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "8.5",
    cy: "17.5",
    r: "1.5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1,26H5c-0.6,0-1-0.4-1-1V14c0-0.6,0.4-1,1-1h5v-2H5c-1.7,0-3,1.3-3,3v11c0,1.7,1.3,3,3,3h4l2.3,4l1.7-1L10.1,26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonToneAnalyzer.propTypes = iconPropTypes;
}
const IbmWatsonxAssistant = /*#__PURE__*/React.forwardRef(function IbmWatsonxAssistant({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "m28,2h-10c-1.1035,0-2,.8965-2,2v6c0,1.1035.8965,2,2,2h2.4229s1.7314,3,1.7314,3l1.7324-1-2.3096-4h-3.5771V4h10v6h-3s0,2,0,2h3c1.1035,0,2-.8965,2-2V4c0-1.1035-.8965-2-2-2Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m14.6904,31l-1.7324-1,3.4648-6h5.5771c1.1046,0,2-.8954,2-2v-5h2v5c0,2.2091-1.7909,4-4,4h-4.4229l-2.8867,5Z"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "17",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "14",
    cy: "17",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "17",
    r: "1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m12,26h-6c-2.2091,0-4-1.7909-4-4v-10c0-2.2091,1.7909-4,4-4h8v2H6c-1.1046,0-2,.8954-2,2v10c0,1.1046.8954,2,2,2h6v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxAssistant.propTypes = iconPropTypes;
}
const IbmWatsonxCodeAssistant = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistant({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "m11,28h-2c-3.8599,0-7-3.1401-7-7v-2h2v2c0,2.7568,2.2432,5,5,5h2v2Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M28.17 26L25.59 28.58 27 30 31 26 27 22 25.58 23.41 28.17 26z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31L20.085 30.4229 23 21 24.9149 21.5771 22 31z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16.83 26L19.41 23.42 18 22 14 26 18 30 19.42 28.59 16.83 26z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "m30,19h-2v-7c0-2.7614-2.2386-5-5-5h-4v-2h4c3.866,0,7,3.134,7,7v7Z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "4",
    r: "1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H16V5H6z"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "12",
    r: "1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11H16V13H6z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H12V17H2z"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "8",
    r: "1"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12V9H2z"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "15",
    cy: "16",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxCodeAssistant.propTypes = iconPropTypes;
}
const IbmWatsonxCodeAssistantForEnterpriseJavaApplications = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForEnterpriseJavaApplications({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9916,19h-2v-7c0-2.7614-2.2386-5-5-5h-8.9948v-2h8.9948c3.866,0,7,3.134,7,7v7ZM11.9916,28h-3c-3.86,0-7-3.14-7-7v-5h2v5c0,2.757,2.243,5,5,5h3v2Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9916,14h-4c-1.103,0-2-.897-2-2v-2h2v2h4V2h2v10c0,1.103-.897,2-2,2Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28.15,26l-2.58,2.58,1.41,1.42,4-4-4-4-1.42,1.41,2.59,2.59ZM16.81,26l2.58-2.58-1.41-1.42-4,4,4,4,1.42-1.41-2.59-2.59ZM21.98,31l-1.915-.577,2.915-9.423,1.915.577-2.915,9.423Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxCodeAssistantForEnterpriseJavaApplications.propTypes = iconPropTypes;
}
const IbmWatsonxCodeAssistantForZ = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZ({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M29.17 25L26.59 27.58 28 29 32 25 28 21 26.58 22.41 29.17 25z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30L21.0851 29.4229 24 20 25.9149 20.5771 23 30z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M17.83 25L20.41 22.42 19 21 15 25 19 29 20.42 27.59 17.83 25z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m18,19h-2V5c0-1.1028.8972-2,2-2h9c1.1028,0,2,.8972,2,2v11h-2V5h-9v14Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m12,3H3c-1.1028,0-2,.8975-2,2v22c0,1.1025.8972,2,2,2h9c1.1028,0,2-.8975,2-2V5c0-1.1025-.8972-2-2-2Zm.0002,7.0366l-6.925-5.0366h6.9248l.0002,5.0366Zm-.7004,1.9634l-8.2998,6.0361V5.9639l8.2998,6.0361Zm.7007,1.9634l.0007,11.8169-8.2795-5.7959,8.2788-6.021Zm-9.0005,7.9575l7.2563,5.0791H3v-5.0791Zm9,5.0791l.0012-.002v.002h-.0012Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxCodeAssistantForZ.propTypes = iconPropTypes;
}
const IbmWatsonxCodeAssistantForZRefactor = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZRefactor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M22.17 16L19.59 18.58 21 20 25 16 21 12 19.58 13.41 22.17 16z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21L13.5851 20.4229 16.5 11 18.4149 11.5771 15.5 21z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83 16L12.41 13.42 11 12 7 16 11 20 12.42 18.59 9.83 16z"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "19",
    cy: "28",
    r: "1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m22,29v-2c2.7568,0,5-2.2432,5-5v-12c0-2.7568-2.2432-5-5-5h-6v-2h6c3.8594,0,7,3.1401,7,7v12c0,3.8594-3.1406,7-7,7Z"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "4",
    r: "1"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m16,29h-6c-3.8594,0-7-3.1406-7-7v-12c0-3.8599,3.1406-7,7-7v2c-2.7568,0-5,2.2432-5,5v12c0,2.7568,2.2432,5,5,5h6v2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxCodeAssistantForZRefactor.propTypes = iconPropTypes;
}
const IbmWatsonxCodeAssistantForZValidationAssistant = /*#__PURE__*/React.forwardRef(function IbmWatsonxCodeAssistantForZValidationAssistant({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2c-7.73,0-14,6.2821-14,14.0269,0,5.0697,2.69,9.5082,6.71,11.9731l1.1-1.6632c-3.48-2.104-5.81-5.9314-5.81-10.3098,0-6.6428,5.37-12.0231,12-12.0231s12,5.396,12,12.0388h2c0-7.7449-6.27-14.0426-14-14.0426ZM14,21.414l-5-5.001,1.413-1.413,3.587,3.586,7.585-7.586,1.415,1.415-9,8.999ZM26.58,24.41l1.42-1.41,4,4-4,4-1.41-1.42,2.58-2.58-2.59-2.59ZM22.5,32l-1.9149-.5771,2.9149-9.4229,1.9149.5771-2.9149,9.4229ZM19.42,29.59l-1.42,1.41-4-4,4-4,1.41,1.42-2.58,2.58,2.59,2.59Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxCodeAssistantForZValidationAssistant.propTypes = iconPropTypes;
}
const IbmWatsonxOrchestrate = /*#__PURE__*/React.forwardRef(function IbmWatsonxOrchestrate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "m27.9248,19.4282c-1.123,1.6104-2.9641,2.5718-4.9248,2.5718-2.1233,0-4.0464-1.0874-5.1438-2.9092l-1.7129,1.0322c1.4624,2.4277,4.0256,3.877,6.8567,3.877,1.4231,0,2.7925-.3911,3.9922-1.0835-2.3442,3.6958-6.4814,6.0835-10.9922,6.0835-5.7104,0-10.8347-3.8184-12.4617-9.2852l-1.917.5703c1.8774,6.3086,7.79,10.7148,14.3787,10.7148s12.5012-4.4062,14.3787-10.7148l-2.4539-.8569Z"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "16",
    r: "2"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "16",
    r: "2"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m16,1C9.4114,1,3.4988,5.4062,1.6213,11.7148l2.4539.8569c1.123-1.6104,2.9641-2.5718,4.9248-2.5718s3.8018.9614,4.9248,2.5718l1.6406-1.144c-1.4971-2.1465-3.9514-3.4277-6.5654-3.4277-1.4231,0-2.7925.3911-3.9922,1.0835,2.3442-3.6953,6.4814-6.0835,10.9922-6.0835,5.7104,0,10.8347,3.8184,12.4617,9.2852l1.917-.5703c-1.8774-6.3086-7.79-10.7148-14.3787-10.7148Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmWatsonxOrchestrate.propTypes = iconPropTypes;
}
const IbmZCloudModStack = /*#__PURE__*/React.forwardRef(function IbmZCloudModStack({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M18.496,27.386L16,28.842L5,22.426v-5.852l10.016-5.843C15.308,10.897,15.641,11,16,11c1.104,0,2-0.896,2-2s-0.896-2-2-2 s-2,0.896-2,2c0,0.003,0.001,0.005,0.001,0.008L3.496,15.136C3.189,15.315,3,15.645,3,16v7c0,0.355,0.189,0.685,0.496,0.864l12,7 C15.652,30.955,15.826,31,16,31s0.348-0.045,0.504-0.136l3-1.75L18.496,27.386z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-3-1.75l-1.008,1.728L27,9.574v12.852l-4.593,2.679l-10.409-6.093C11.999,19.007,12,19.004,12,19 c0-1.104-0.896-2-2-2s-2,0.896-2,2s0.896,2,2,2c0.358,0,0.69-0.102,0.981-0.267l10.92,6.393c0.156,0.091,0.331,0.137,0.505,0.137 c0.174,0,0.348-0.045,0.504-0.136l5.594-3.263C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17.277V5.5c0-0.355-0.189-0.685-0.496-0.864l-6-3.5C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7 C3.189,8.315,3,8.645,3,9v2.999h2V9.574l11-6.417l5,2.917v11.203c-0.595,0.347-1,0.984-1,1.723c0,1.104,0.896,2,2,2s2-0.896,2-2 C24,18.262,23.595,17.624,23,17.277z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZCloudModStack.propTypes = iconPropTypes;
}
const IbmZEnvironmentsDevSecOps = /*#__PURE__*/React.forwardRef(function IbmZEnvironmentsDevSecOps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5,16v2c3.0327,0,5.5,2.4673,5.5,5.5s-2.4673,5.5-5.5,5.5-5.5-2.4673-5.5-5.5h-2c0,4.1422,3.3578,7.5,7.5,7.5s7.5-3.3578,7.5-7.5-3.3578-7.5-7.5-7.5Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5,26c1.3807,0,2.5-1.1193,2.5-2.5s-1.1193-2.5-2.5-2.5c-.3217,0-.6268.066-.9093.1766l-4.8837-4.8837-1.4141,1.4141,4.8837,4.8837c-.1107.2825-.1766.5876-.1766.9093,0,1.3807,1.1193,2.5,2.5,2.5Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m29,13h-2v-3.4257l-11-6.4166-3,1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12,7c.3071.1792.4961.5081.4961.8638v4Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H9V16H7z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m13.9998,29.991l-10.5037-6.1272c-.3071-.1792-.4961-.5081-.4961-.8638v-14h2v13.4257l10.0076,5.8378-1.0078,1.7275Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZEnvironmentsDevSecOps.propTypes = iconPropTypes;
}
const IbmZOpenEditor = /*#__PURE__*/React.forwardRef(function IbmZOpenEditor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M29,13h-2v-3.4257l-11-6.4166-3,1.7499v8.0924h-2V4.3333c0-.3557.189-.6846.4961-.8638l4-2.3333c.1558-.0908.3298-.1362.5039-.1362s.3481.0454.5039.1362l12,7c.3071.1792.4961.5081.4961.8638v4ZM7,16h2V6h-2v10ZM15,28.2718l-10.0013-5.8403v-13.4315h-1.9987v14.006c0,.3559.1889.6849.4958.8642l10.4971,6.1298,1.0072-1.7282h-.0001ZM26,17l-1.4141,1.4141,3.5854,3.5859-3.5854,3.5859,1.4141,1.4141,5-5-5-5ZM15,22l5,5,1.4141-1.4141-3.5854-3.5859,3.5854-3.5859-1.4141-1.4141-5,5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZOpenEditor.propTypes = iconPropTypes;
}
const IbmZProcessorCapacityReference = /*#__PURE__*/React.forwardRef(function IbmZProcessorCapacityReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H27V29H25z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23H23V29H21z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M29 20H31V29H29z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "m30,17V5c0-1.1046-.8954-2-2-2h-9c-1.1046,0-2,.8954-2,2v24h2V5h9v12h2Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m13,3H4c-1.1046,0-2,.8954-2,2v22c0,1.1046.8954,2,2,2h9c1.1046,0,2-.8954,2-2V5c0-1.1046-.8954-2-2-2Zm-9,2.9635l8.2998,6.0365-8.2998,6.0365V5.9635Zm0,21.0365v-5.0366l6.9253,5.0366h-6.9253Zm9-.9635l-8.2998-6.0365,8.2998-6.0365v12.073Zm0-15.9999l-6.9253-5.0366h6.9253v5.0366Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZProcessorCapacityReference.propTypes = iconPropTypes;
}
const IbmZCloudProvisioning = /*#__PURE__*/React.forwardRef(function IbmZCloudProvisioning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H14V21H10z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H21V14H17z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17H21V21H17z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M19.758,26.65L16,28.842L5,22.426V18H3v5c0,0.355,0.189,0.685,0.496,0.864l12,7C15.652,30.955,15.826,31,16,31 s0.348-0.045,0.504-0.136l4.282-2.498L19.758,26.65z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-4.269-2.49l-1.029,1.715L27,9.574v12.852l-3.787,2.209l1.029,1.715l4.262-2.486 C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M5,9.574l11-6.417l3.751,2.188L20.78,3.63l-4.276-2.494C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7 C3.189,8.315,3,8.645,3,9v5h2V9.574z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZCloudProvisioning.propTypes = iconPropTypes;
}
const IbmZOs = /*#__PURE__*/React.forwardRef(function IbmZOs({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "m16,32c-5.0793,0-9.7449-2.3319-12.7998-6.3979l1.5991-1.2014c2.6736,3.5585,6.7561,5.5994,11.2007,5.5994s8.5281-2.0413,11.2014-5.6005l1.5991,1.2012c-3.0547,4.0668-7.7202,6.3993-12.8005,6.3993Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "m30,22h-5v-2h5v-3h-3c-1.1028,0-2-.8972-2-2v-3c0-1.1028.8972-2,2-2h5v2h-5v3h3c1.1028,0,2,.8972,2,2v3c0,1.1028-.8972,2-2,2Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m21,22h-4c-1.1028,0-2-.8972-2-2v-8c0-1.1028.8972-2,2-2h4c1.1028,0,2,.8972,2,2v8c0,1.1028-.8972,2-2,2Zm-4-10v8h4v-8h-4Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4458 10L7.4458 22 9.5542 22 13.5542 10 11.4458 10z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22L0 22 0 19.6973 3.7981 14 0 14 0 12 6 12 6 14.3027 2.2019 20 6 20 6 22z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m16.0001,0C10.9207,0,6.2552,2.3319,3.2003,6.3979l1.5991,1.2014c2.6736-3.5585,6.7561-5.5994,11.2007-5.5994s8.5281,2.0413,11.2014,5.6005l1.5991-1.2012C25.7459,2.3325,21.0804,0,16.0001,0Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZOs.propTypes = iconPropTypes;
}
const IbmZOsAiControlInterface = /*#__PURE__*/React.forwardRef(function IbmZOsAiControlInterface({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "21",
    r: "1"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m23,25h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "11",
    r: "1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m23,15h-14c-1.1028,0-2-.8972-2-2v-4c0-1.1028.8972-2,2-2h14c1.1028,0,2,.8972,2,2v4c0,1.1028-.8972,2-2,2Zm-14-6v4h14v-4h-14Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m28,30H4c-1.103,0-2-.897-2-2v-12h2v12h24V4h-12v-2h12c1.103,0,2,.897,2,2v24c0,1.103-.897,2-2,2Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5H13.5V3.5H8.5z",
    transform: "rotate(90 11 2.5)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1.975 3.475H6.975V5.475H1.975z",
    transform: "rotate(45 4.475 4.475)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H5V12H0z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZOsAiControlInterface.propTypes = iconPropTypes;
}
const IbmZOsContainers = /*#__PURE__*/React.forwardRef(function IbmZOsContainers({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "m29,12h-9V3h9v9Zm-7-2h5v-5h-5v5Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m20,15v2h7v10h-10V3H5c-1.1028,0-2,.8975-2,2v22c0,1.1025.8972,2,2,2h22c1.1028,0,2-.8975,2-2v-12h-9Zm-13.5859,2h8.5859v8.5859l-8.5859-8.5859Zm8.5859-2H6.4141L15,6.4141v8.5859Zm-1.4141-10L5,13.5859V5h8.5859Zm-8.5859,13.4141l8.5859,8.5859H5v-8.5859Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZOsContainers.propTypes = iconPropTypes;
}
const IbmZOsPackageManager = /*#__PURE__*/React.forwardRef(function IbmZOsPackageManager({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M15,9v10.172l-2.586-2.586L11,18l5,5l5-5l-1.414-1.414L17,19.172V9H15z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M19.758,26.65L16,28.842L5,22.426V18H3v5c0,0.355,0.189,0.685,0.496,0.864l12,7C15.652,30.955,15.826,31,16,31 s0.348-0.045,0.504-0.136l4.282-2.498L19.758,26.65z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M28.504,8.136l-4.269-2.49l-1.029,1.715L27,9.574v12.852l-3.787,2.209l1.029,1.715l4.262-2.486 C28.811,23.685,29,23.355,29,23V9C29,8.645,28.811,8.315,28.504,8.136z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M5,9.574l11-6.417l3.751,2.188L20.78,3.63l-4.276-2.494C16.348,1.045,16.174,1,16,1s-0.348,0.045-0.504,0.136l-12,7 C3.189,8.315,3,8.645,3,9v5h2V9.574z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IbmZOsPackageManager.propTypes = iconPropTypes;
}
const WatsonHealthICa_2D = /*#__PURE__*/React.forwardRef(function WatsonHealthICa_2D({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24H10a2.0023,2.0023,0,0,1-2-2V10a2.0023,2.0023,0,0,1,2-2H22a2.0023,2.0023,0,0,1,2,2V22A2.0023,2.0023,0,0,1,22,24ZM10,10V22H22V10Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21L2 30 11 30 11 28 4 28 4 21 2 21z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11L30 2 21 2 21 4 28 4 28 11 30 11z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M21 30L30 30 30 21 28 21 28 28 21 28 21 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthICa_2D.propTypes = iconPropTypes;
}
const IceAccretion = /*#__PURE__*/React.forwardRef(function IceAccretion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M4,2A2,2,0,0,0,2,4V20l1,2,1-2V4H8V14l1,2,1-2V2Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H14v8l1,2,1-2V4h2V17l1,2,1-2V4h4V14l1,2,1-2V4h2V24l1,2,1-2V4A2,2,0,0,0,28,2Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28L13 30 12 28 12 16 14 16 14 28z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26L23 28 22 26 22 20 24 20 24 26z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24L7 26 6 24 6 18 8 18 8 24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IceAccretion.propTypes = iconPropTypes;
}
const IceVision = /*#__PURE__*/React.forwardRef(function IceVision({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14L19 21 20 23 21 21 21 14 19 14z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M17,14H13a2,2,0,0,0-2,2v4l1,2,1-2V16h2v7l1,2,1-2Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IceVision.propTypes = iconPropTypes;
}
const QID = /*#__PURE__*/React.forwardRef(function QID({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9H12V11H10z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14V9h4a4,4,0,0,1,4,4v6A4,4,0,0,1,18,23Zm-2-2h2a2,2,0,0,0,2-2V13a2,2,0,0,0-2-2H16Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V23H10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  QID.propTypes = iconPropTypes;
}
const IdManagement = /*#__PURE__*/React.forwardRef(function IdManagement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M15,20H9a3,3,0,0,0-3,3v2H8V23a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V23A3,3,0,0,0,15,20Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M12,19a4,4,0,1,0-4-4A4,4,0,0,0,12,19Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,12,13Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19v9H4V8H16V6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19H26V21H20z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23H26V25H22z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M32,10V8H29.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,26,4.1011V2H24V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,20.1011,8H18v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,24,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,29.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,25,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IdManagement.propTypes = iconPropTypes;
}
const Idea = /*#__PURE__*/React.forwardRef(function Idea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A10,10,0,0,0,6,12a9.19,9.19,0,0,0,3.46,7.62c1,.93,1.54,1.46,1.54,2.38h2c0-1.84-1.11-2.87-2.19-3.86A7.2,7.2,0,0,1,8,12a8,8,0,0,1,16,0,7.2,7.2,0,0,1-2.82,6.14c-1.07,1-2.18,2-2.18,3.86h2c0-.92.53-1.45,1.54-2.39A9.18,9.18,0,0,0,26,12,10,10,0,0,0,16,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Idea.propTypes = iconPropTypes;
}
const Identification = /*#__PURE__*/React.forwardRef(function Identification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H13V12H6z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H10V16H6z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M23,18H17a3,3,0,0,0-3,3v2h2V21a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V21A3,3,0,0,0,23,18Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M20,17a4,4,0,1,0-4-4A4,4,0,0,0,20,17Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Identification.propTypes = iconPropTypes;
}
const IfAction = /*#__PURE__*/React.forwardRef(function IfAction({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2h-10C6,2,2,6,2,11v10c0,5,4,9,9,9h10c5,0,9-4,9-9v-10c0-5-4-9-9-9ZM28,21c0,3.9-3.1,7-7,7h-10c-3.9,0-7-3.1-7-7v-10c0-3.9,3.1-7,7-7h10c3.9,0,7,3.1,7,7v10ZM9.8755,22v-1.8232h1.582v-8.3574h-1.582v-1.8223h5.4512v1.8223h-1.5991v8.3574h1.5991v1.8232h-5.4512ZM17.959,14.7363h-1.3242v-1.7363h1.3242v-1.2666c0-1.582.8599-2.459,2.4761-2.459h1.5649v1.7539h-1.8398v1.9717h1.8398v1.7363h-1.8398v7.2637h-2.2012v-7.2637Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IfAction.propTypes = iconPropTypes;
}
const Image = /*#__PURE__*/React.forwardRef(function Image({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,22H6V20l5-5,5.59,5.59a2,2,0,0,0,2.82,0L21,19l5,5Zm0-4.83-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17l-5.59-5.59a2,2,0,0,0-2.82,0L6,17.17V6H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Image.propTypes = iconPropTypes;
}
const ImageCopy = /*#__PURE__*/React.forwardRef(function ImageCopy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M4,22H2V4A2.0023,2.0023,0,0,1,4,2H22V4H4Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M21,17a3,3,0,1,0-3-3A3.0033,3.0033,0,0,0,21,17Zm0-4a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,21,13Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H9A2.0025,2.0025,0,0,0,7,9V28a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V9A2.0025,2.0025,0,0,0,28,7Zm0,21H9v-6l4-3.9971,5.5859,5.586a2,2,0,0,0,2.8282,0L23,22.0034,28,27Zm0-3.8281-3.5859-3.586a2,2,0,0,0-2.8282,0L20,22.1719l-5.5859-5.586a2,2,0,0,0-2.8282,0L9,19.1719V9H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImageCopy.propTypes = iconPropTypes;
}
const ImageMedical = /*#__PURE__*/React.forwardRef(function ImageMedical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6V26H6V6H26m0-2H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16L22 14 17 14 17 12 20 12 20 10 17 10 17 8 15 8 15 10 12 10 12 12 15 12 15 14 10 14 10 16 15 16 15 18 10 18 10 20 15 20 15 22 12 22 12 24 20 24 20 22 17 22 17 20 22 20 22 18 17 18 17 16 22 16z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImageMedical.propTypes = iconPropTypes;
}
const ImageReference = /*#__PURE__*/React.forwardRef(function ImageReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M19,14a3,3,0,1,0-3-3A3,3,0,0,0,19,14Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,19,10Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V16H6V6H26V21.17l-3.59-3.59a2,2,0,0,0-2.82,0L18,19.17,11.8308,13l-1.4151,1.4155L14,18l2.59,2.59a2,2,0,0,0,2.82,0L21,19l5,5v2H16v2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImageReference.propTypes = iconPropTypes;
}
const ImageSearch = /*#__PURE__*/React.forwardRef(function ImageSearch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14a5.99,5.99,0,0,0-4.885,9.4712L14,28.5859,15.4141,30l5.1147-5.1147A5.9971,5.9971,0,1,0,24,14Zm0,10a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,24,24Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M17,12a3,3,0,1,0-3-3A3.0033,3.0033,0,0,0,17,12Zm0-4a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,17,8Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M12,24H4V17.9966L9,13l5.5859,5.5859L16,17.168l-5.5859-5.5855a2,2,0,0,0-2.8282,0L4,15.168V4H24v6h2V4a2.0023,2.0023,0,0,0-2-2H4A2.002,2.002,0,0,0,2,4V24a2.0023,2.0023,0,0,0,2,2h8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImageSearch.propTypes = iconPropTypes;
}
const ImageSearchAlt = /*#__PURE__*/React.forwardRef(function ImageSearchAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16a5.9908,5.9908,0,0,0,9.4712,4.8853L24.5859,26,26,24.5859l-5.115-5.1147A5.997,5.997,0,1,0,10,16Zm2,0a4,4,0,1,1,4,4A4.0045,4.0045,0,0,1,12,16Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M29,7H22.54L20.83,4.45A.9946.9946,0,0,0,20,4H12a.9946.9946,0,0,0-.83.45L9.46,7H3A1.0031,1.0031,0,0,0,2,8V25a1.0031,1.0031,0,0,0,1,1h9V24H4V9h6a.9946.9946,0,0,0,.83-.45L12.54,6h6.92l1.71,2.55A.9946.9946,0,0,0,22,9h6V21h2V8A1.0031,1.0031,0,0,0,29,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImageSearchAlt.propTypes = iconPropTypes;
}
const WatsonHealthImageAvailabilityLocal = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityLocal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S18.8,18,16,18z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0 c0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13 c0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthImageAvailabilityLocal.propTypes = iconPropTypes;
}
const WatsonHealthImageAvailabilityRetrieving = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityRetrieving({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13L11.4 11.6 15 15.2 15 2 17 2 17 15.2 20.6 11.6 22 13 16 19z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.8V5c3,1.5,5,4.5,5,8c0,2-0.6,3.8-1.8,5.4c0,0-0.2,0.3-0.3,0.4L16,26.9l-6.9-8.1c-0.1-0.1-0.3-0.4-0.3-0.4 C7.6,16.8,7,15,7,13c0-3.5,2-6.6,5-8V2.8C7.9,4.4,5,8.3,5,13c0,2.4,0.8,4.7,2.2,6.6c0,0,0.3,0.4,0.3,0.5L16,30l8.4-10 c0-0.1,0.3-0.4,0.3-0.4l0,0c1.4-1.9,2.2-4.2,2.2-6.6C27,8.3,24.1,4.4,20,2.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthImageAvailabilityRetrieving.propTypes = iconPropTypes;
}
const WatsonHealthImageAvailabilityUnavailable = /*#__PURE__*/React.forwardRef(function WatsonHealthImageAvailabilityUnavailable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "20.5",
    r: "1.5"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h-2v-4h2c1.1,0,2-0.9,2-2s-0.9-2-2-2h-2c-1.1,0-2,0.9-2,2v0.5h-2V11c0-2.2,1.8-4,4-4h2c2.2,0,4,1.8,4,4s-1.8,4-4,4V17 z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-8.4-9.9c0-0.1-0.3-0.5-0.3-0.5C5.8,17.7,5,15.4,5,13C5,6.9,9.9,2,16,2s11,4.9,11,11c0,2.4-0.8,4.7-2.2,6.6l0,0 c0,0-0.3,0.4-0.3,0.4L16,30z M8.8,18.4c0,0,0.2,0.3,0.3,0.4l6.9,8.1l6.9-8.1c0-0.1,0.3-0.4,0.3-0.4C24.4,16.8,25,15,25,13 c0-5-4-9-9-9s-9,4-9,9C7,15,7.6,16.8,8.8,18.4L8.8,18.4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthImageAvailabilityUnavailable.propTypes = iconPropTypes;
}
const ImageService = /*#__PURE__*/React.forwardRef(function ImageService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H26v2h2v6H4V22H6V20H4a2.0024,2.0024,0,0,0-2,2v6a2.0024,2.0024,0,0,0,2,2H28a2.0024,2.0024,0,0,0,2-2V22A2.0024,2.0024,0,0,0,28,20Z"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4H15V12H13z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4H11V12H9z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M21,12H19a2.0021,2.0021,0,0,1-2-2V6a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,21,12ZM19,6v4h2V6Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14H23V22H21z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H11V22H9z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M17,22H15a2.0021,2.0021,0,0,1-2-2V16a2.0021,2.0021,0,0,1,2-2h2a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,17,22Zm-2-6v4h2V16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImageService.propTypes = iconPropTypes;
}
const ImageStoreLocal = /*#__PURE__*/React.forwardRef(function ImageStoreLocal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m25,2v7h7V2h-7Zm5,5h-3v-3h3v3Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23,6h-7v12h12v-7h-5v-5Zm-2,10h-3v-3h3v3Zm5-3v3h-3v-3h3Zm-8-2v-3h3v3h-3Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m26,20v2H6v-14h8v-2H6c-1.104.0011-1.999.8959-2,2v14c.0012,1.104.896,1.9987,2,2h20c1.104-.0015,1.9985-.8961,2-2v-2h-2Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M2 26H30V28H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImageStoreLocal.propTypes = iconPropTypes;
}
const ImportExport = /*#__PURE__*/React.forwardRef(function ImportExport({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24v4H4V24H2v4l.0076-.0049A1.9977,1.9977,0,0,0,4,30H28a2,2,0,0,0,2-2h0V24Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 14.6L24 18.2 24 4 22 4 22 18.2 18.4 14.6 17 16 23 22 29 16 27.6 14.6z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4L3 10 4.4 11.4 8 7.8 8 22 10 22 10 7.8 13.6 11.4 15 10 9 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImportExport.propTypes = iconPropTypes;
}
const ImproveRelevance = /*#__PURE__*/React.forwardRef(function ImproveRelevance({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26.59L19.41 24 18 25.41 22 29.41 30 21.41 28.59 20 22 26.59z"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0066,6.0066,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16A12,12,0,1,0,16,28V26A10,10,0,1,1,26,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  ImproveRelevance.propTypes = iconPropTypes;
}
const InProgress = /*#__PURE__*/React.forwardRef(function InProgress({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm0,26A12,12,0,0,1,16,4V16l8.4812,8.4814A11.9625,11.9625,0,0,1,16,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InProgress.propTypes = iconPropTypes;
}
const InProgressError = /*#__PURE__*/React.forwardRef(function InProgressError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2a12,12,0,1,0,2,23.8193v-2.021A10,10,0,1,1,14,4V14l4.343,4.3433A7.9751,7.9751,0,0,1,24,16h1.8193A11.93,11.93,0,0,0,14,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InProgressError.propTypes = iconPropTypes;
}
const InProgressWarning = /*#__PURE__*/React.forwardRef(function InProgressWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M18.746,22.7993A9.999,9.999,0,1,1,14,4V14l6.0971,6.0972,1.22-2.44A2.9849,2.9849,0,0,1,24,16h1.8193A11.993,11.993,0,1,0,14,26a11.9337,11.9337,0,0,0,3.3939-.4966Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InProgressWarning.propTypes = iconPropTypes;
}
const IncidentReporter = /*#__PURE__*/React.forwardRef(function IncidentReporter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M10,13h12v2h-12v-2ZM10,20h8v-2h-8v2ZM10,25h5v-2h-5v2ZM7,7h3v3h12v-3h3v6h2v-6c0-1.1045-.8955-2-2-2h-3v-1c0-1.1045-.8955-2-2-2h-8c-1.1045,0-2,.8955-2,2v1h-3c-1.1045,0-2,.8955-2,2v21c0,1.1045.8955,2,2,2h5v-2h-5V7ZM12,4h8v4h-8v-4ZM29.9108,28.9355l-6.2831-11.5649c-.2739-.4941-.9829-.4941-1.2568,0l-6.2831,11.5649c-.2607.48.0862,1.0645.6316,1.0645h12.5599c.5453,0,.8923-.5845.6315-1.0645ZM22.2493,21h1.5v4h-1.5v-4ZM22.9993,28c-.5522,0-.9993-.4478-.9993-1s.4478-1,1-1,1,.4478,1,1-.4485,1-1.0007,1Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IncidentReporter.propTypes = iconPropTypes;
}
const Incomplete = /*#__PURE__*/React.forwardRef(function Incomplete({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
      d: "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,4a4.0045,4.0045,0,0,1,4,4H4A4.0045,4.0045,0,0,1,8,4Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7642,6.8593l1.2851-1.5315A13.976,13.976,0,0,0,20.8672,2.887l-.6836,1.8776A11.9729,11.9729,0,0,1,23.7642,6.8593Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M27.81,14l1.9677-.4128A13.8888,13.8888,0,0,0,28.14,9.0457L26.4087,10A12.52,12.52,0,0,1,27.81,14Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1836,27.2354l.6836,1.8776a13.976,13.976,0,0,0,4.1821-2.4408l-1.2851-1.5315A11.9729,11.9729,0,0,1,20.1836,27.2354Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4087,22,28.14,23a14.14,14.14,0,0,0,1.6382-4.5872L27.81,18.0659A12.1519,12.1519,0,0,1,26.4087,22Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30V2a14,14,0,0,0,0,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Incomplete.propTypes = iconPropTypes;
}
const IncompleteCancel = /*#__PURE__*/React.forwardRef(function IncompleteCancel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21.41L28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25 30 21.41z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26A12,12,0,0,1,14,2Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8257,4.7642a10.0288,10.0288,0,0,1,3.2422,2.1679l1.4133-1.4135a12.0359,12.0359,0,0,0-3.89-2.6016Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14a11.93,11.93,0,0,0-.9167-4.5908l-1.8472.7651A9.9428,9.9428,0,0,1,24,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IncompleteCancel.propTypes = iconPropTypes;
}
const IncompleteError = /*#__PURE__*/React.forwardRef(function IncompleteError({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26A12,12,0,0,1,14,2Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8257,4.7642a10.0288,10.0288,0,0,1,3.2422,2.1679l1.4133-1.4135a12.0359,12.0359,0,0,0-3.89-2.6016Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14a11.93,11.93,0,0,0-.9167-4.5908l-1.8472.7651A9.9428,9.9428,0,0,1,24,14Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IncompleteError.propTypes = iconPropTypes;
}
const IncompleteWarning = /*#__PURE__*/React.forwardRef(function IncompleteWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26A12,12,0,0,1,14,2Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8257,4.7642a10.0288,10.0288,0,0,1,3.2422,2.1679l1.4133-1.4135a12.0359,12.0359,0,0,0-3.89-2.6016Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14a11.93,11.93,0,0,0-.9167-4.5908l-1.8472.7651A9.9428,9.9428,0,0,1,24,14Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M27.38,28H20.6178L24,21.2358ZM24,18a1,1,0,0,0-.8947.5527l-5,10A1.0005,1.0005,0,0,0,19,30H29a1,1,0,0,0,.9214-1.3892L24.8946,18.5527A1,1,0,0,0,24,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IncompleteWarning.propTypes = iconPropTypes;
}
const IncreaseLevel = /*#__PURE__*/React.forwardRef(function IncreaseLevel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M23 4L18 7.75 18 14.25 15 12 10 15.75 10 22.25 7 20 2 23.75 2 30 4 30 4 24.75 7 22.5 10 24.75 10 30 12 30 12 16.75 15 14.5 18 16.75 18 30 20 30 20 8.75 23 6.5 26 8.75 26 30 28 30 28 7.75 23 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IncreaseLevel.propTypes = iconPropTypes;
}
const Industry = /*#__PURE__*/React.forwardRef(function Industry({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M29.53,6.15a1,1,0,0,0-1,0L20,10.38V7a1,1,0,0,0-1.45-.89L10,10.38V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V28H30V7A1,1,0,0,0,29.53,6.15ZM22,26H18V19h4Zm6,0H24V18a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1v8H4V4H8v9.62l10-5v5l10-5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Industry.propTypes = iconPropTypes;
}
const InfinitySymbol = /*#__PURE__*/React.forwardRef(function InfinitySymbol({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "m23,23c-5.6558,0-7.8577-6.4109-7.9487-6.6837-.0173-.0514-1.8435-5.3163-6.0513-5.3163-2.7571,0-5,2.243-5,5s2.2429,5,5,5c1.5876,0,3.0134-.7322,4.2373-2.1764l1.5259,1.2932c-1.5989,1.8862-3.5916,2.8832-5.7632,2.8832-3.8599,0-7-3.1401-7-7s3.1401-7,7-7c5.6558,0,7.8577,6.4109,7.9487,6.6837.0173.0514,1.8435,5.3163,6.0513,5.3163,2.7571,0,5-2.243,5-5s-2.2429-5-5-5c-1.5876,0-3.0134.7322-4.2373,2.1764l-1.5259-1.2932c1.5989-1.8862,3.5916-2.8832,5.7632-2.8832,3.8599,0,7,3.1401,7,7s-3.1401,7-7,7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InfinitySymbol.propTypes = iconPropTypes;
}
const Information = /*#__PURE__*/React.forwardRef(function Information({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
      d: "M8.5 11L8.5 6.5 6.5 6.5 6.5 7.5 7.5 7.5 7.5 11 6 11 6 12 10 12 10 11z"
    })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
      d: "M8,3.5c-0.4,0-0.8,0.3-0.8,0.8S7.6,5,8,5c0.4,0,0.8-0.3,0.8-0.8S8.4,3.5,8,3.5z"
    })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
      d: "M8,15c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S11.9,15,8,15z M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Information.propTypes = iconPropTypes;
}
const InformationDisabled = /*#__PURE__*/React.forwardRef(function InformationDisabled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M30,3.4141,28.5859,2,2,28.5859,3.4141,30l3.4433-3.4434A13.9614,13.9614,0,0,0,26.5565,6.8574ZM28,16A11.9734,11.9734,0,0,1,8.2678,25.146L15,18.4141V22H13v2h7V22H17V16.4141l8.146-8.146A11.8967,11.8967,0,0,1,28,16Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67,22.0854A11.9829,11.9829,0,0,1,22.0856,5.67L23.54,4.2163A13.985,13.985,0,0,0,4.2162,23.54Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InformationDisabled.propTypes = iconPropTypes;
}
const InformationFilled = /*#__PURE__*/React.forwardRef(function InformationFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
    "data-icon-path": "inner-path"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,6a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InformationFilled.propTypes = iconPropTypes;
}
const InformationSquare = /*#__PURE__*/React.forwardRef(function InformationSquare({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22L17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,6,4H26a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,26,28ZM6,6V26H26V6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InformationSquare.propTypes = iconPropTypes;
}
const InformationSquareFilled = /*#__PURE__*/React.forwardRef(function InformationSquareFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,13.875H17.125v-8H13v2.25h1.875v5.75H12v2.25h8Z",
    "data-icon-path": "inner-path"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4ZM16,8a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,16,8Zm4,16.125H12v-2.25h2.875v-5.75H13v-2.25h4.125v8H20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InformationSquareFilled.propTypes = iconPropTypes;
}
const InfrastructureClassic = /*#__PURE__*/React.forwardRef(function InfrastructureClassic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26H30V28H18z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21H30V23H18z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16H30V18H18z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M14,25H9.5A7.4964,7.4964,0,0,1,8.1782,10.124,10,10,0,0,1,28,12H26a7.999,7.999,0,0,0-15.9507-.87l-.09.8335L9.123,12.02A5.4962,5.4962,0,0,0,9.5,23H14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InfrastructureClassic.propTypes = iconPropTypes;
}
const Insert = /*#__PURE__*/React.forwardRef(function Insert({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M2,9h9V2H2ZM4,4H9V7H4Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M2,19h9V12H2Zm2-5H9v3H4Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M2,29h9V22H2Zm2-5H9v3H4Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M27,9H18l3.41-3.59L20,4l-6,6,6,6,1.41-1.41L18,11h9a1,1,0,0,1,1,1V24a1,1,0,0,1-1,1H15v2H27a3,3,0,0,0,3-3V12A3,3,0,0,0,27,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Insert.propTypes = iconPropTypes;
}
const InsertPage = /*#__PURE__*/React.forwardRef(function InsertPage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V20H12V30H10V20a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17 16L2 19.17 3.411 20.589 8 16 3.42 11.42 2 12.83 5.17 16z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14H12a2.0021,2.0021,0,0,1-2-2V2h2V12H24V2h2V12A2.0021,2.0021,0,0,1,24,14Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InsertPage.propTypes = iconPropTypes;
}
const InsertSyntax = /*#__PURE__*/React.forwardRef(function InsertSyntax({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 16L17.59 18.58 19 20 23 16 19 12 17.58 13.41 20.17 16z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M11.83 16L14.41 13.42 13 12 9 16 13 20 14.42 18.59 11.83 16z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.142V9.858A3.9916,3.9916,0,1,0,22.142,5H9.858A3.9916,3.9916,0,1,0,5,9.858V22.142A3.9916,3.9916,0,1,0,9.858,27H22.142A3.9916,3.9916,0,1,0,27,22.142ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.002,2.002,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Zm16.142-3H9.858A3.9937,3.9937,0,0,0,7,22.142V9.858A3.9947,3.9947,0,0,0,9.858,7H22.142A3.9937,3.9937,0,0,0,25,9.858V22.142A3.9931,3.9931,0,0,0,22.142,25ZM26,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,26,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InsertSyntax.propTypes = iconPropTypes;
}
const Inspection = /*#__PURE__*/React.forwardRef(function Inspection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.18L12.41 14.59 11 16 15 20 22 13 20.59 11.59 15 17.18z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15H27.9492A12.0071,12.0071,0,0,0,17,4.0508V2H15V4.0508A12.0071,12.0071,0,0,0,4.0508,15H2v2H4.0508A12.0071,12.0071,0,0,0,15,27.9492V30h2V27.9492A12.0071,12.0071,0,0,0,27.9492,17H30ZM17,25.9492V23H15v2.9492A10.0166,10.0166,0,0,1,6.0508,17H9V15H6.0508A10.0166,10.0166,0,0,1,15,6.0508V9h2V6.0508A10.0166,10.0166,0,0,1,25.9492,15H23v2h2.949A10.0165,10.0165,0,0,1,17,25.9492Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Inspection.propTypes = iconPropTypes;
}
const InstanceBx = /*#__PURE__*/React.forwardRef(function InstanceBx({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M12,5A3.0033,3.0033,0,0,0,9,2H4V15H9a3.0033,3.0033,0,0,0,3-3V10.5a2.977,2.977,0,0,0-.78-2,2.9768,2.9768,0,0,0,.78-2ZM6,4H9a1.0013,1.0013,0,0,1,1,1V6.5513A.9587.9587,0,0,1,9,7.5H6Zm4,8a1.0009,1.0009,0,0,1-1,1H6V9.5H9a1.0009,1.0009,0,0,1,1,1Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H18V20H14z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H24V20H20z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H30V20H26z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M26,31H6a2.0021,2.0021,0,0,1-2-2V25a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,31ZM6,25v4H26V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InstanceBx.propTypes = iconPropTypes;
}
const InstanceClassic = /*#__PURE__*/React.forwardRef(function InstanceClassic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,21H23V19h.5a4.4975,4.4975,0,0,0,.3564-8.981l-.8154-.0639-.0986-.812a6.9938,6.9938,0,0,0-13.8838,0l-.0991.812-.8155.0639A4.4975,4.4975,0,0,0,8.5,19H9v2H8.5A6.4973,6.4973,0,0,1,7.2,8.1362a8.9943,8.9943,0,0,1,17.6006,0A6.4974,6.4974,0,0,1,23.5,21Z"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M26,23H17V15.83l2.59,2.58L21,17l-5-5-5,5,1.41,1.41L15,15.83V23H6a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V25A2.0023,2.0023,0,0,0,26,23Zm0,6H6V25H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InstanceClassic.propTypes = iconPropTypes;
}
const InstanceCx = /*#__PURE__*/React.forwardRef(function InstanceCx({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15H6a2.0023,2.0023,0,0,1-2-2V4A2.002,2.002,0,0,1,6,2h6V4H6v9h6Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H18V20H14z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H24V20H20z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H30V20H26z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M26,31H6a2.0021,2.0021,0,0,1-2-2V25a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,31ZM6,25v4H26V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InstanceCx.propTypes = iconPropTypes;
}
const InstanceMx = /*#__PURE__*/React.forwardRef(function InstanceMx({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5L20 5 18 8.897 16 5 14 5 16.905 10 14 15 16 15 18 11.201 20 15 22 15 19.098 10 22 5z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2L8.485 6.374 8 8 7.535 6.374 6 2 4 2 4 15 6 15 6 7.374 5.841 5.378 6.421 7.374 8 12 9.579 7.374 10.159 5.374 10 7.374 10 15 12 15 12 2 10 2z"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "27",
    r: "1"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V20H2z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H12V20H8z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H18V20H14z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H24V20H20z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18H30V20H26z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M26,31H6a2.0021,2.0021,0,0,1-2-2V25a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2v4A2.0021,2.0021,0,0,1,26,31ZM6,25v4H26V25Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InstanceMx.propTypes = iconPropTypes;
}
const InstanceVirtual = /*#__PURE__*/React.forwardRef(function InstanceVirtual({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "23",
    r: "1"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H6V8H2z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H12V8H8z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H18V8H14z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H24V8H20z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6H30V8H26z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V20a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,28ZM4,20v6H28V20Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H30V14H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InstanceVirtual.propTypes = iconPropTypes;
}
const Integration = /*#__PURE__*/React.forwardRef(function Integration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M29.88,15.52l-6-11A1,1,0,0,0,23,4H9a1,1,0,0,0-.88.52l-6,11a1,1,0,0,0,0,1l6,11A1,1,0,0,0,9,28H23a1,1,0,0,0,.88-.52l6-11A1,1,0,0,0,29.88,15.52ZM22.93,7l4.39,8h-9.5ZM16,14.14,10.82,6H21.18ZM9.07,7l5.11,8H4.68ZM4.68,17h9.5L9.07,25ZM16,17.86,21.18,26H10.82ZM22.93,25l-5.11-8h9.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Integration.propTypes = iconPropTypes;
}
const IntentRequestActive = /*#__PURE__*/React.forwardRef(function IntentRequestActive({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.2L20.4 24.6 19 26 23 30 31 22 29.6 20.6z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntentRequestActive.propTypes = iconPropTypes;
}
const IntentRequestCreate = /*#__PURE__*/React.forwardRef(function IntentRequestCreate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24L26 24 26 20 24 20 24 24 20 24 20 26 24 26 24 30 26 30 26 26 30 26z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntentRequestCreate.propTypes = iconPropTypes;
}
const IntentRequestHeal = /*#__PURE__*/React.forwardRef(function IntentRequestHeal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M27,20c-0.8,0-1.5,0.3-2.1,0.9l-0.4,0.5l-0.4-0.5C23.5,20.3,22.7,20,22,20s-1.5,0.3-2.1,0.9c-1.2,1.2-1.2,3.1,0,4.3l4.6,4.8 l4.6-4.8c1.2-1.2,1.2-3.1,0-4.3C28.6,20.3,27.8,20,27,20L27,20z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6,28.6L4,16L16,4l12.6,12.6l1.4-1.4L17.5,2.6c-0.8-0.8-2.1-0.8-2.9,0L2.6,14.5c-0.8,0.8-0.8,2.1,0,2.9L15.1,30 L16.6,28.6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntentRequestHeal.propTypes = iconPropTypes;
}
const IntentRequestInactive = /*#__PURE__*/React.forwardRef(function IntentRequestInactive({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: "18.5",
    cy: "22.5",
    r: "1.5"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: "23.5",
    cy: "22.5",
    r: "1.5"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: "28.5",
    cy: "22.5",
    r: "1.5"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntentRequestInactive.propTypes = iconPropTypes;
}
const IntentRequestScaleIn = /*#__PURE__*/React.forwardRef(function IntentRequestScaleIn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6 30L30 28.6 22.4 21 29 21 29 19 19 19 19 29 21 29 21 22.4z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28.6L3.4 30 11 22.4 11 29 13 29 13 19 3 19 3 21 9.6 21z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2L15 2 15 12.2 10.4 7.6 9 9 16 16 23 9 21.6 7.6 17 12.2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntentRequestScaleIn.propTypes = iconPropTypes;
}
const IntentRequestScaleOut = /*#__PURE__*/React.forwardRef(function IntentRequestScaleOut({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.4L20.4 19 28 26.6 28 20 30 20 30 30 20 30 20 28 26.6 28z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20.4L11.6 19 4 26.6 4 20 2 20 2 30 12 30 12 28 5.4 28z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16L15 16 15 5.8 10.4 10.4 9 9 16 2 23 9 21.6 10.4 17 5.8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntentRequestScaleOut.propTypes = iconPropTypes;
}
const IntentRequestUninstall = /*#__PURE__*/React.forwardRef(function IntentRequestUninstall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21.4L28.6 20 25 23.6 21.4 20 20 21.4 23.6 25 20 28.6 21.4 30 25 26.4 28.6 30 30 28.6 26.4 25z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntentRequestUninstall.propTypes = iconPropTypes;
}
const IntentRequestUpgrade = /*#__PURE__*/React.forwardRef(function IntentRequestUpgrade({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23L26.6 24.4 24 21.8 24 30 22 30 22 21.8 19.4 24.4 18 23 23 18z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4,30L5,23.8c-0.6-0.4-1-1-1-1.7V9.9c0-0.7,0.4-1.4,1-1.7l10-5.9C15.3,2.1,15.6,2,16,2c0.4,0,0.7,0.1,1,0.3l10,5.9 c0.6,0.4,1,1,1,1.7V16h-2V9.9L16,4L6,9.9v12.2l10.5,6.2L15.4,30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntentRequestUpgrade.propTypes = iconPropTypes;
}
const Interactions = /*#__PURE__*/React.forwardRef(function Interactions({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      d: "M11,7 L11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 L14,10 L14,13 C14,13.5522847 13.5522847,14 13,14 L13,14 L10,14 L10,7 L11,7 Z M5,9 C5.55228475,9 6,9.44771525 6,10 L6,10 L6,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,13 L2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L5,11 L5,10 L2.5,10 L2.5,9 Z M13,10 L11,10 L11,13 L13,13 L13,10 Z M5,12 L3,12 L3,13 L5,13 L5,12 Z M7.912,2 L7.834,3.911 L9.628,3.248 L9.914,4.119 L8.068,4.626 L9.251,6.134 L8.523,6.667 L7.457,5.068 L6.391,6.667 L5.663,6.134 L6.846,4.626 L5,4.119 L5.286,3.248 L7.08,3.911 L7.002,2 L7.912,2 Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H22V14H20V28h6a2.0027,2.0027,0,0,0,2-2V20A2.0023,2.0023,0,0,0,26,18Zm-4,8V20h4v6Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.076L19.256 4.219 16 5.522 16 2 14 2 14 5.523 10.744 4.22 10 6.077 13.417 7.444 10.9 10.8 12.5 12 15 8.667 17.5 12 19.1 10.8 16.583 7.443 20 6.076z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M10,18H5v2h5v2H6a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V20A2.0023,2.0023,0,0,0,10,18Zm0,8H6V24h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Interactions.propTypes = iconPropTypes;
}
const WatsonHealthInteractiveSegmentationCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthInteractiveSegmentationCursor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4139,24,15.9989,10.5663a2.0473,2.0473,0,0,0-2.8281,0l-2.586,2.586a2.0023,2.0023,0,0,0,0,2.8283L23.9989,29.4145a2.0021,2.0021,0,0,0,2.8281,0l2.5869-2.5865a1.9993,1.9993,0,0,0,0-2.8283Zm-17.415-9.4335,2.5859-2.5859,3.5,3.5L15.498,18.0676l-3.5-3.5ZM25.413,28l-8.5009-8.5188,2.5867-2.587L28,25.4143Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M7.586 18.586H10.414V21.413999999999998H7.586z",
    transform: "rotate(-45 9 20)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M18.586 7.586H21.413999999999998V10.414H18.586z",
    transform: "rotate(-45 20 9)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M7.586 7.586H10.414V10.414H7.586z",
    transform: "rotate(-45 9 9)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2L2 2 2 11 4 11 4 4 11 4 11 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  WatsonHealthInteractiveSegmentationCursor.propTypes = iconPropTypes;
}
const InterfaceUsage = /*#__PURE__*/React.forwardRef(function InterfaceUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m18.3242,11.7334v1.29h-1.3242v1.7368h1.3242v7.2397h2.2012v-7.2397h1.8398v-1.7368h-1.8398v-1.9951h1.8398v-1.7539h-1.5649c-1.6167,0-2.4761.877-2.4761,2.459Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M10 11.8193L11.582 11.8193 11.582 20.1772 10 20.1772 10 22 15.4516 22 15.4516 20.1772 13.8525 20.1772 13.8525 11.8193 15.4516 11.8193 15.4516 9.9966 10 9.9966 10 11.8193z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InterfaceUsage.propTypes = iconPropTypes;
}
const InterfaceUsage_1 = /*#__PURE__*/React.forwardRef(function InterfaceUsage_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0259,30h-10c-5,0-9-4-9-9v-10C2.0259,6,6.0259,2,11.0259,2h10c5,0,9,4,9,9v10c0,5-4,9-9,9ZM11.0259,4c-3.9,0-7,3.1-7,7v10c0,3.9,3.1,7,7,7h10c3.9,0,7-3.1,7-7v-10c0-3.9-3.1-7-7-7h-10ZM9,22.0029v-1.8232h1.582v-8.3574h-1.582v-1.8223h5.4512v1.8223h-1.5991v8.3574h1.5991v1.8232h-5.4512ZM16.3301,22.0029v-9.0029h2.2012v1.5225h.0859c.3613-.9629,1.1182-1.7021,2.5107-1.7021,1.8403,0,2.8721,1.2725,2.8721,3.5078v5.6748h-2.2012v-5.4512c0-1.2725-.4302-1.9258-1.479-1.9258-.9116,0-1.7886.4814-1.7886,1.4443v5.9326h-2.2012Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InterfaceUsage_1.propTypes = iconPropTypes;
}
const InterfaceUsageAlt = /*#__PURE__*/React.forwardRef(function InterfaceUsageAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19h-3c-2.2056,0-4,1.7944-4,4h-2v-14c0-1.1025-.8972-2-2-2h-2v-1c0-2.2056-1.7944-4-4-4h-3c-2.2056,0-4,1.7944-4,4v3c0,2.2056,1.7944,4,4,4h3c2.2056,0,4-1.7944,4-4h2v14c0,1.1025.8972,2,2,2h2v1c0,2.2056,1.7944,4,4,4h3c2.2056,0,4-1.7944,4-4v-3c0-2.2056-1.7944-4-4-4ZM11,9c0,1.1025-.8972,2-2,2h-3c-1.1028,0-2-.8975-2-2v-3c0-1.1025.8972-2,2-2h3c1.1028,0,2,.8975,2,2v3ZM28,26c0,1.1025-.8972,2-2,2h-3c-1.1028,0-2-.8975-2-2v-3c0-1.1025.8972-2,2-2h3c1.1028,0,2,.8975,2,2v3Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InterfaceUsageAlt.propTypes = iconPropTypes;
}
const InterfaceDefinitionAlt = /*#__PURE__*/React.forwardRef(function InterfaceDefinitionAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4c-1.1,0-2-.9-2-2V4c0-1.1.9-2,2-2h24c1.1,0,2,.9,2,2v24c0,1.1-.9,2-2,2ZM4,28h24V4H4v24ZM9,22v-1.8232h1.582v-8.3545h-1.582v-1.8223h5.4512v1.8223h-1.5991v8.3545h1.5991v1.8232h-5.4512ZM16.3301,22v-9h2.2012v1.5195h.0859c.3613-.9629,1.1182-1.7021,2.5107-1.7021,1.8403,0,2.8721,1.2725,2.8721,3.5078v5.6748h-2.2012v-5.4512c0-1.2725-.4302-1.9258-1.479-1.9258-.9116,0-1.7886.4814-1.7886,1.4443v5.9326h-2.2012Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InterfaceDefinitionAlt.propTypes = iconPropTypes;
}
const InterfaceDefinition = /*#__PURE__*/React.forwardRef(function InterfaceDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M28,19h-7c-1.1028,0-2,.8975-2,2v2h-2v-14c0-1.1025-.8972-2-2-2h-2v-3c0-1.1025-.8972-2-2-2h-7c-1.1028,0-2,.8975-2,2v7c0,1.1025.8972,2,2,2h7c1.1028,0,2-.8975,2-2v-2h2v14c0,1.1025.8972,2,2,2h2v3c0,1.1025.8972,2,2,2h7c1.1028,0,2-.8975,2-2v-7c0-1.1025-.8972-2-2-2ZM11,11h-7v-7h7v7ZM28,28h-7v-7h7v7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InterfaceDefinition.propTypes = iconPropTypes;
}
const Intersect = /*#__PURE__*/React.forwardRef(function Intersect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24H18V22h4V18h2v4A2.0021,2.0021,0,0,1,22,24Z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M10,14H8V10a2.0022,2.0022,0,0,1,2-2h4v2H10Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H24V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V22a2.0023,2.0023,0,0,0,2,2H8v4a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V10A2.0023,2.0023,0,0,0,28,8Zm0,20H10V24h4V22H10V18H8v4H4V4H22V8H18v2h4v4h2V10h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  Intersect.propTypes = iconPropTypes;
}
const IntrusionPrevention = /*#__PURE__*/React.forwardRef(function IntrusionPrevention({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "23.887",
    r: "2"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7769,23.4785A8.64,8.64,0,0,0,22,18a8.64,8.64,0,0,0-7.7769,5.4785L14,24l.2231.5215A8.64,8.64,0,0,0,22,30a8.64,8.64,0,0,0,7.7769-5.4785L30,24ZM22,28a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,28Z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M25,10H4A2.0021,2.0021,0,0,1,2,8V4A2.0021,2.0021,0,0,1,4,2H25a2.0021,2.0021,0,0,1,2,2V8A2.0021,2.0021,0,0,1,25,10ZM4,4V8H25V4Z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H4V24h8V22H4a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h8Z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H7a2.0023,2.0023,0,0,0-2,2v4a2.0023,2.0023,0,0,0,2,2h5V18H7V14H28l.0007,2H30V14A2.0023,2.0023,0,0,0,28,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IntrusionPrevention.propTypes = iconPropTypes;
}
const InventoryManagement = /*#__PURE__*/React.forwardRef(function InventoryManagement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M19 24H23V28H19z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24H30V28H26z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17H23V21H19z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M26 17H30V21H26z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M17,24H4V10H28v5h2V10a2.0023,2.0023,0,0,0-2-2H22V4a2.0023,2.0023,0,0,0-2-2H12a2.002,2.002,0,0,0-2,2V8H4a2.002,2.002,0,0,0-2,2V24a2.0023,2.0023,0,0,0,2,2H17ZM12,4h8V8H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  InventoryManagement.propTypes = iconPropTypes;
}
const IotConnect = /*#__PURE__*/React.forwardRef(function IotConnect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19H26V15H24v9H8V8l9-.0009V6H13V2H11V6H8A2.002,2.002,0,0,0,6,8v3H2v2H6v6H2v2H6v3a2.0023,2.0023,0,0,0,2,2h3v4h2V26h6v4h2V26h3a2.0027,2.0027,0,0,0,2-2V21h4Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2a4.0042,4.0042,0,0,0-4,4,3.9556,3.9556,0,0,0,.5668,2.0192L19.5859,11H11V21H21V12.4141l2.9808-2.9808A3.9553,3.9553,0,0,0,26,10a4,4,0,0,0,0-8ZM19,19H13V13h6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {
  IotConnect.propTypes = iconPropTypes;
}

export { IbmCloudPakApplications, IbmCloudPakBusinessAutomation, IbmCloudPakData, IbmCloudPakIntegration, IbmCloudPakMantaAutomatedDataLineage, IbmCloudPakMulticloudMgmt, IbmCloudPakNetezza, IbmCloudPakNetworkAutomation, IbmCloudPakSecurity, IbmCloudPakSystem, IbmCloudPakWatsonAiops, IbmCloudVirtualServerVpc, IbmCloudVpc, IbmCloudVpcBlockStorageSnapshots, IbmCloudVpcClientVpn, IbmCloudVpcEndpoints, IbmCloudVpcFileStorage, IbmCloudVpcImages, IbmConsultingAdvantageAgent, IbmConsultingAdvantageApplication, IbmConsultingAdvantageAssistant, IbmDevopsControl, IbmQuantumSafeAdvisor, IbmQuantumSafeExplorer, IbmQuantumSafeRemediator, IbmSecurity, IbmSecurityServices, IbmWatsonAssistant, IbmWatsonDiscovery, IbmWatsonKnowledgeCatalog, IbmWatsonKnowledgeStudio, IbmWatsonLanguageTranslator, IbmWatsonMachineLearning, IbmWatsonNaturalLanguageClassifier, IbmWatsonNaturalLanguageUnderstanding, IbmWatsonOpenscale, IbmWatsonOrders, IbmWatsonQuery, IbmWatsonSpeechToText, IbmWatsonStudio, IbmWatsonTextToSpeech, IbmWatsonToneAnalyzer, IbmWatsonxAssistant, IbmWatsonxCodeAssistant, IbmWatsonxCodeAssistantForEnterpriseJavaApplications, IbmWatsonxCodeAssistantForZ, IbmWatsonxCodeAssistantForZRefactor, IbmWatsonxCodeAssistantForZValidationAssistant, IbmWatsonxOrchestrate, IbmZCloudModStack, IbmZCloudProvisioning, IbmZEnvironmentsDevSecOps, IbmZOpenEditor, IbmZOs, IbmZOsAiControlInterface, IbmZOsContainers, IbmZOsPackageManager, IbmZProcessorCapacityReference, IceAccretion, IceVision, IdManagement, Idea, Identification, IfAction, Image, ImageCopy, ImageMedical, ImageReference, ImageSearch, ImageSearchAlt, ImageService, ImageStoreLocal, ImportExport, ImproveRelevance, InProgress, InProgressError, InProgressWarning, IncidentReporter, Incomplete, IncompleteCancel, IncompleteError, IncompleteWarning, IncreaseLevel, Industry, InfinitySymbol, Information, InformationDisabled, InformationFilled, InformationSquare, InformationSquareFilled, InfrastructureClassic, Insert, InsertPage, InsertSyntax, Inspection, InstanceBx, InstanceClassic, InstanceCx, InstanceMx, InstanceVirtual, Integration, IntentRequestActive, IntentRequestCreate, IntentRequestHeal, IntentRequestInactive, IntentRequestScaleIn, IntentRequestScaleOut, IntentRequestUninstall, IntentRequestUpgrade, Interactions, InterfaceDefinition, InterfaceDefinitionAlt, InterfaceUsage, InterfaceUsageAlt, InterfaceUsage_1, Intersect, IntrusionPrevention, InventoryManagement, IotConnect, QID, WatsonHealthICa_2D, WatsonHealthImageAvailabilityLocal, WatsonHealthImageAvailabilityRetrieving, WatsonHealthImageAvailabilityUnavailable, WatsonHealthInteractiveSegmentationCursor };
